/* eslint-disable new-cap */
import { css } from "styled-components";
import {
  Button1Styles,
  H1Styles,
  Variant
} from "@arcteryx/components-typography";

export const FormStyles = css`
  #content {
    clear: both;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  @media screen and (min-width: 930px) {
    #content {
      width: 930px;
    }
  }

  .URBAN #content {
    overflow: visible !important;
  }

  body#ProductFind #content {
    padding-top: 25px;
  }

  #minorContent {
    z-index: 3;
    position: relative;
  }

  @media screen and (min-width: 930px) {
    #minorContent {
      width: 290px;
      float: left;
    }
  }

  .SERVICE-FORMS #minorContent {
    margin-bottom: 20px;
  }

  @media screen and (max-width: 768px) {
    #leftButtonOne,
    #leftButtonTwo {
      display: none;
    }

    #leftSiloOne {
      display: none !important;
    }

    .SERVICE-FORMS #leftSiloOne {
      display: block !important;
      padding: 0;
    }
  }

  .leftButton {
    width: 100%;
    float: left;
    height: 29px;
    z-index: 5;
  }

  #leftButtonTwo {
    display: none;
  }

  .leftButton h2,
  .leftButton h3,
  .leftButtonFull h2,
  .leftButtonFull h3 {
    padding-top: 3px;
  }

  .silo {
    clear: both;
    overflow: hidden;
    padding: 16px 30px 30px 0;
    position: relative;
    z-index: 4;
  }

  .silo img {
    border: 1px solid #999;
  }

  a.blank:after,
  .blank:after {
    content: url("//images.arcteryx.com/foundation-ui/svgs/New_Window.svg");
    height: 12px;
    width: 12px;
    display: inline-block;
    padding-left: 3px;
    margin-top: -10px;
    position: absolute;
  }

  a.underline {
    text-decoration: underline !important;
  }

  .divSiloCartStatus {
    display: none;
    padding-top: 17px;
    background-image: url(//images.arcteryx.com/misc/cart.png);
    background-position: left 18px;
    background-repeat: no-repeat;
    padding-left: 23px;
    width: 150px;
  }

  #contactSilo h3 {
    margin: 30px 0 37px;
  }

  #contactMoreLinks {
    margin-top: 30px;
  }

  #contactMoreLinks li {
    margin-bottom: 11px;
  }

  #contactMoreLinks li h4 {
    font-family: var(--font-helvetica);
  }

  #rss {
    margin-top: 30px;
  }

  #rssIcon {
    float: left;
    border: 0px;
    margin-right: 5px;
  }

  body.ARTICLE div.siloReadMoreNews {
    display: none;
  }

  .menucat {
    margin-bottom: 30px;
  }

  .menucat li {
    margin-bottom: 11px;
  }

  body.LOGGEDIN .menucat li.loggedIn {
    display: none;
  }

  #mainContent {
    padding-bottom: 30px;
  }

  @media screen and (min-width: 930px) {
    #mainContent {
      float: right;
      width: 610px;
    }
  }

  .thumbnailContainer,
  .SHOP #divArticleFull,
  .TEAM #divArticleFull,
  .PURCHASE #divArticleFull,
  .HELPPAGE #divArticleFull {
    margin-right: -3%;
  }

  @media screen and (min-width: 930px) {
    .thumbnailContainer,
    .SHOP #divArticleFull,
    .TEAM #divArticleFull,
    .PURCHASE #divArticleFull,
    .HELPPAGE #divArticleFull {
      margin-right: -30px;
    }
  }

  .searchResult {
    background-position: center center;
    float: left;
    width: 130px;
    height: 130px;
    margin-bottom: 30px;
    margin-right: 30px;
    padding: 0;
    overflow: hidden;
    position: relative;
    cursor: pointer;
  }

  @media screen and (max-width: 767px) {
    .searchResult {
      background-size: cover;
      width: 138px;
      height: 138px;
      margin: 0 12px 12px 0;
    }
  }

  .HELPPAGE .searchResult {
    width: 160px;
    height: 160px;
  }

  .searchResult:hover {
    text-decoration: none !important;
  }

  .searchResult4 {
    width: 290px !important;
    height: 290px !important;
  }

  @media screen and (max-width: 767px) {
    .searchResult4 {
      height: 262px !important;
      margin: 0 11px 12px 0;
    }
  }

  .searchResult4leftHalf {
    float: left;
    width: 145px;
    height: 290px;
    overflow: hidden;
  }

  @media screen and (max-width: 767px) {
    .searchResult4leftHalf {
      width: 138px;
    }
  }

  .searchResult4leftHalf img {
    width: 100%;
    height: 100%;
  }

  .HELPPAGE .searchResult4leftHalf img {
    width: auto;
    height: auto;
  }

  .searchResult4rightHalf {
    display: block;
    height: 270px;
    margin: 5px 0 0 160px;
    position: relative;
  }

  @media screen and (max-width: 767px) {
    .searchResult4rightHalf {
      margin: 0 0 0 163px;
    }
  }

  .searchResult2w {
    width: 290px !important;
  }

  @media screen and (max-width: 767px) {
    .searchResult2w {
      margin: 0 11px 12px 0;
    }
  }

  @media screen and (max-width: 929px) {
    .HELPPAGE .searchResult2w {
      width: 90% !important;
    }
  }

  .HELPPAGE.NORWEGIAN .searchResult2w,
  .HELPPAGE.FRENCH .searchResult2w,
  .HELPPAGE.GERMAN .searchResult2w {
    height: 210px;
  }

  @media screen and (min-width: 414px) {
    .HELPPAGE.NORWEGIAN .searchResult2w,
    .HELPPAGE.FRENCH .searchResult2w,
    .HELPPAGE.GERMAN .searchResult2w {
      height: 180px;
    }
  }

  .HELPPAGE.SPANISH .searchResult2w,
  .HELPPAGE.NORWEGIAN .searchResult2w,
  .HELPPAGE.FRENCH .searchResult2w,
  .HELPPAGE.GERMAN .searchResult2w {
    height: 210px;
  }

  @media screen and (min-width: 414px) {
    .HELPPAGE.SPANISH .searchResult2w,
    .HELPPAGE.NORWEGIAN .searchResult2w,
    .HELPPAGE.FRENCH .searchResult2w,
    .HELPPAGE.GERMAN .searchResult2w {
      height: 240px;
    }
  }

  .searchResult2t {
    height: 290px !important;
  }

  .newsSiloResult {
    display: block;
    width: 168px;
    margin-right: 0;
    background-repeat: no-repeat;
    float: none;
  }

  .searchResultFeaturedHeadline {
    margin-bottom: 1em;
  }

  .searchResultName {
    background: var(--colour-black);
    border: none;
    font-weight: normal;
    text-transform: uppercase;
    text-align: center;
    color: #ededed;
    width: 128px;
    min-height: 11px;
    margin: 0;
    padding: 7px 1px;
    position: absolute;
    bottom: 0;
    z-index: 90;
  }

  @media screen and (max-width: 767px) {
    .searchResultName {
      width: 141px;
    }
  }

  .PARTNERS .searchResultName,
  .ONLINE-DEALERS .searchResultName,
  .FIND-A-STORE .searchResultName {
    display: none;
  }

  .partnerLogo {
    display: block;
    height: 130px;
    width: 130px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100%;
    overflow: hidden;
  }

  @media screen and (max-width: 929px) {
    .ATHLETES #leftSiloTwo {
      display: none;
    }
  }

  .athleteTeam {
    clear: both;
    overflow: auto;
  }

  .athleteTeam h2 {
    margin: 16px 0 10px;
  }

  .athleteNewsFeaturedLink {
    display: block;
    margin-bottom: 1em;
    font-weight: normal;
  }

  .athleteNewsFeaturedTeaser {
    display: block;
    margin-bottom: 1em;
    font-weight: normal;
  }

  .athleteNewsFeaturedBioLinks {
    position: absolute;
    bottom: 0;
  }

  .athleteMedia {
    width: 218px;
    max-width: 50%;
    float: right;
    margin: 53px 0 0px 10px;
  }

  .athleteMedia img {
    max-width: 100%;
  }

  .athleteMediaSelector {
    padding-top: 10px;
    margin: 0 0 20px 0;
    overflow: auto;
  }

  .athleteMediaThumbnails {
    clear: both;
    padding: 0 0 0px 10px;
  }

  .athleteMediaThumb {
    float: left;
    display: inline;
    width: 42px;
    height: 42px;
    margin: 0 10px 10px 0;
  }

  #divAthleteMenu {
    margin-bottom: 15px;
  }

  #divAthleteMenu span:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .athleteText {
    display: none;
  }

  #divAthleteBio {
    display: block;
  }

  #divAthleteBio #socialNavColor {
    overflow: auto;
  }

  .error-tooltip {
    border-color: #900 !important;
    background-color: #f99 !important;
  }

  .ui-tooltip {
    background: #2b2b2b;
    color: #fff;
    border-radius: 3px;
    padding: 8px;
    position: absolute;
    z-index: 9999;
    max-width: 300px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .ui-tooltip::after {
    position: absolute;
    content: "";
    display: block;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom-width: 0;
    border-top-color: #2b2b2b;
    left: 50%;
    margin-left: -10px;
    top: 100%;
  }

  @media screen and (max-width: 767px) {
    .ui-tooltip {
      max-width: none;
      width: 100%;
      left: 0 !important;
      border-radius: 0;
    }

    .ui-tooltip::after {
      right: 0;
      left: initial;
      margin-right: 12%;
    }
  }

  .ui-helper-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .mobileOnly {
    display: none;
  }

  @media screen and (max-width: 767px) {
    .mobileNo {
      display: none !important;
    }

    .mobileOnly {
      display: block;
    }
  }

  .SERVICE-FORMS.JP .mobileOnly {
    display: none !important;
  }

  .tel-number a {
    display: inline;
  }

  .playBtn {
    height: 58px;
    width: 58px;
    margin: 10px auto 20px auto;
    background-color: rgba(0, 0, 0, 0.7);
    -webkit-transition: background-color 0.5s ease;
    transition: background-color 0.5s ease;
    border-radius: 100%;
    position: relative;
    border: 2px solid white;
    -webkit-box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.6);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.6);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .playBtn:hover {
    background-color: var(--colour-black);
    -webkit-transition: background-color 0.5s ease;
    transition: background-color 0.5s ease;
    cursor: pointer;
  }

  .playBtn:after {
    content: "";
    display: block;
    position: absolute;
    top: 15px;
    left: 20px;
    margin: 0 auto;
    border-style: solid;
    border-width: 12px 0 12px 21px;
    border-color: transparent transparent transparent #fff;
  }

  .is-iframe.hide-scroll::-webkit-scrollbar {
    display: none;
  }

  .is-iframe.hide-scroll {
    scrollbar-width: none;
  }

  .hidden,
  .is-hidden {
    display: none !important;
  }

  .hide-offscreen {
    position: absolute !important;
    top: 100%;
  }

  .center-align {
    text-align: center;
  }

  .NOTLOGGEDIN .notLoggedIn {
    display: initial;
  }

  .NOTLOGGEDIN .isLoggedIn {
    display: none;
  }

  .LOGGEDIN .notLoggedIn {
    display: none;
  }

  .LOGGEDIN .isLoggedIn {
    display: initial;
  }

  .deadBirdLoadAnim:after {
    display: block;
    content: "";
    position: absolute;
    top: 30%;
    left: 50%;
    width: 60px;
    height: 60px;
    z-index: -1;
    border-radius: 100%;
    background-color: white;
    outline: 1px solid transparent;
    -webkit-animation: pulseanim 1.2s ease-in-out infinite;
    animation: pulseanim 1.2s ease-in-out infinite;
    margin: -30px -30px;
    z-index: 99;
  }

  .deadBirdLoadAnim:after {
    content: url("//images.arcteryx.com/foundation-ui/svgs/ArcBirdWhite.svg");
    top: 30%;
    left: 50%;
    position: absolute;
    -webkit-transform: translate(-18px, -11px);
    transform: translate(-18px, -11px);
    height: 28px;
    width: 42px;
    z-index: 100;
  }

  html,
  body {
    padding: 0;
    margin: 0;
    width: 100%;
    position: relative;
    z-index: 0;
  }

  html {
    background: #fff none;
    height: 100%;
    overflow-y: scroll;
  }

  html.NOSCROLL {
    overflow: hidden;
  }

  body.HOME {
    background: #fff;
  }

  body.HOME.LEAF {
    background: var(--colour-black);
  }

  table {
    border: 0px;
    border-collapse: collapse;
  }

  table td {
    border: 0px;
  }

  form {
    padding: 0;
    margin: 0;
    display: inline;
  }

  input,
  select {
    background: #f2f2f2;
    border: 0;
    margin: 0;
    padding: 0;
  }

  input[type="text"],
  input[type="button"],
  input[type="submit"] {
    -webkit-appearance: none;
    border-radius: 0;
  }

  input:focus,
  select:focus {
    outline: none;
  }

  input[type="hidden"] {
    display: none !important;
  }

  fieldset {
    padding: 0;
    margin: 0;
  }

  legend {
    padding: 0;
    margin: 0;
    color: var(--colour-black);
  }

  noscript {
    background-color: var(--colour-black);
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    top: 15px;
    right: 15px;
    padding: 15px;
    z-index: 9999;
    opacity: 0.6;
    pointer-events: none;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=60)";
  }

  .js noscript {
    display: none;
  }

  body.ajaxing * {
    cursor: progress !important;
  }

  .leafcontent {
    display: none;
  }

  .HOME #minorContent {
    display: none !important;
  }

  body,
  div,
  dl,
  dt,
  dd,
  ul,
  ol,
  li,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  pre,
  form,
  fieldset,
  p,
  blockquote,
  th,
  td {
    margin: 0;
    padding: 0;
  }

  body {
    font-family: var(--font-helvetica);
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.5rem;
    color: var(--colour-black);
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeSpeed;
    -webkit-text-size-adjust: 100%;
    overflow-x: hidden;
  }

  .searchResultHeader {
    clear: both;
    margin-top: -9px;
    margin-bottom: 4px;
  }

  #minorContent h4 a:link,
  #minorContent h4 a:hover,
  #minorContent h4 a:active,
  #minorContent h4 a:visited {
    font-weight: normal;
  }

  #minorContent #divHeadlineNews {
    padding: 0 0 15px;
  }

  .silo,
  #content .silo p {
    font-family: Arial, sans-serif;
    font-size: 15px;
    line-height: 1.5em;
    color: var(--colour-black);
  }

  a {
    color: var(--colour-black);
  }

  #mainContent a:visited,
  #dragHelper a:link,
  #dragHelper a:visited {
    text-decoration: none;
  }

  #mainContent a:active {
    text-decoration: underline;
  }

  #minorContent a,
  #mainContent a {
    text-decoration: underline;
  }

  @media screen and (min-width: 930px) {
    #minorContent a,
    #mainContent a {
      text-decoration: none;
    }
  }

  #minorContent a:hover,
  #mainContent a:hover {
    text-decoration: underline;
  }

  .no-touch a:hover {
    text-decoration: underline;
  }

  #content a,
  .product__below-the-fold a {
    text-decoration: none;
  }

  #content a:hover,
  .product__below-the-fold a:hover {
    text-decoration: underline !important;
  }

  .HOME #content a:hover,
  .HOME .product__below-the-fold a:hover {
    text-decoration: none !important;
  }

  @media screen and (max-width: 767px) {
    #content a,
    .product__below-the-fold a {
      text-decoration: underline;
    }

    #content a.feature-button,
    #content a.button,
    .product__below-the-fold a.feature-button,
    .product__below-the-fold a.button {
      text-decoration: none;
    }
  }

  #content h1 a,
  #content #olapic_specific_widget a,
  #content .BVQAAskQuestion a,
  #content .searchLink a,
  #content #divFindBreadcrumb a,
  #content .breadcrumb a,
  #content .searchResult a,
  #content a.feature-button,
  #content .catIntroPrimary a,
  #content #search-results-no-results a,
  #content .continue-shopping a,
  #content .whatsnew a,
  #content .shop-home-page a,
  #content .shop-cta,
  #content a.full-overlay,
  #content a.active,
  #content #footer a,
  #content #app a.back-button,
  #content #app .product-container a,
  #content .continue-shopping a,
  #content .product-tile-inner a,
  #content .sizing-category-wrapper a {
    text-decoration: none !important;
  }

  #content h1 a:hover,
  #content #olapic_specific_widget a:hover,
  #content .BVQAAskQuestion a:hover,
  #content .searchLink a:hover,
  #content #divFindBreadcrumb a:hover,
  #content .breadcrumb a:hover,
  #content .searchResult a:hover,
  #content a.feature-button:hover,
  #content .catIntroPrimary a:hover,
  #content #search-results-no-results a:hover,
  #content .continue-shopping a:hover,
  #content .whatsnew a:hover,
  #content .shop-home-page a:hover,
  #content .shop-cta:hover,
  #content a.full-overlay:hover,
  #content a.active:hover,
  #content #footer a:hover,
  #content #app a.back-button:hover,
  #content #app .product-container a:hover,
  #content .continue-shopping a:hover,
  #content .product-tile-inner a:hover,
  #content .sizing-category-wrapper a:hover {
    text-decoration: none !important;
  }

  .HOME #content a,
  .SHOP #content a,
  .SHOPHOME #content a {
    text-decoration: none;
  }

  .HOME #content a:hover,
  .SHOP #content a:hover,
  .SHOPHOME #content a:hover {
    text-decoration: none !important;
  }

  input,
  textarea {
    font-family: Arial, sans-serif;
    font-size: 12px;
  }

  .dropProductName {
    font-family: Arial, sans-serif;
    font-size: 11px;
  }

  .menuCat .sublink {
    color: #b3b3b3;
    font-family: var(--font-helvetica);
    font-size: 12px;
    font-weight: normal;
    margin-left: 9px;
  }

  .menuCat .menuSubCat {
    margin: 0 0 13px 10px;
  }

  .menuCat .menuSubCat li {
    margin: 6px 0 2px;
  }

  .menuCat .menuSubCat h4 a {
    font-family: var(--font-helvetica);
    font-size: 12px;
    font-weight: normal;
  }

  .PRODUCTFIND .searchResult {
    font-size: 12px;
    line-height: 16px;
    color: var(--colour-black);
  }

  .PRODUCTFIND .subMarketName {
    text-transform: capitalize;
    color: #808080;
  }

  #divProductBetaWidgetInner h1 {
    font-size: 16px;
  }

  @media screen and (max-width: 767px) {
    .NEWS #divNewsContainer a .searchResultName {
      font-size: 12px;
    }
  }

  .productBetaWindow h4,
  .reviewsBetaTab {
    font-weight: normal;
    font-size: 16px;
    font-family: var(--font-helvetica);
    text-transform: uppercase;
    clear: left;
  }

  #reviewsBetaTabQuestions {
    padding: 0 0 20px;
  }

  .overlay-dark--full {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
    z-index: 250;
  }

  .overlay-dark--circle {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    background: radial-gradient(
      circle,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0)
    );
    opacity: 1;
    z-index: 1;
  }

  @media screen and (max-width: 767px) {
    .overlay-dark--circle {
      background: rgba(0, 0, 0, 0.5);
    }
  }

  .overlay-dark--left {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      from(rgba(0, 0, 0, 0.8)),
      to(rgba(0, 0, 0, 0.2))
    );
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.2)
    );
    opacity: 1;
    z-index: 1;
  }

  @media screen and (max-width: 767px) {
    .overlay-dark--left {
      background: rgba(0, 0, 0, 0.5);
    }
  }

  .overlay-light-dark--left {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      from(rgba(0, 0, 0, 0.3)),
      to(rgba(0, 0, 0, 0.1))
    );
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0.1)
    );
    opacity: 1;
    z-index: 1;
  }

  @media screen and (max-width: 767px) {
    .overlay-light-dark--left {
      background: rgba(0, 0, 0, 0.3);
    }
  }

  a.button {
    background: #e6e6e6;
    border: 1px solid #666;
    display: inline-block;
    height: auto;
    text-decoration: none;
    margin: 0 0 13px;
    padding: 6px 10px;
    zoom: 1;
  }

  a.button:hover {
    text-decoration: none;
  }

  .button,
  .divButton {
    display: inline-block;
    zoom: 1;
    margin-top: 11px;
  }

  @media screen and (max-width: 767px) {
    .button,
    .divButton {
      padding: 0;
    }
  }

  .feature-button {
    font: 16px / 16px var(--font-helvetica);
    color: white;
    background: rgba(0, 0, 0, 0.75);
    padding: 9px 16px 9px 15px;
    border: 1px solid white;
    cursor: pointer;
    margin: 7px 0 14px 0;
    outline: none;
    text-transform: uppercase;
    -webkit-transition: background-color 0.5s ease;
    transition: background-color 0.5s ease;
    display: inline-block;
    text-shadow: none !important;
  }

  .feature-button:hover {
    background: black;
    text-decoration: none !important;
  }

  @media screen and (max-width: 767px) {
    .feature-button {
      padding: 13px 16px 13px 15px;
    }
  }

  .SPANISH .feature-button {
    font-size: 14px !important;
  }

  input.button,
  .blackButton a,
  .button.black,
  .button input,
  .button a,
  .button span,
  .divButton button,
  .divButton input,
  .button #paymentProcessing,
  #btnValidateCode {
    background-color: #e6e6e6;
    background-position: 0 0;
    border: 1px solid #e6e6e6;
    border-radius: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: var(--colour-black);
    cursor: pointer;
    display: inline-block;
    font: normal 14px/30px var(--font-helvetica);
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    height: 30px;
    padding: 0 15px;
    zoom: 1;
    -webkit-appearance: none;
  }

  input.button:hover,
  .blackButton a:hover,
  .button.black:hover,
  .button input:hover,
  .button a:hover,
  .button span:hover,
  .divButton button:hover,
  .divButton input:hover,
  .button #paymentProcessing:hover,
  #btnValidateCode:hover {
    border: 1px solid #cfcfcf;
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#ededed),
      to(#d9d9d9)
    );
    background-image: linear-gradient(#ededed, #d9d9d9);
  }

  input.button:active,
  .blackButton a:active,
  .button.black:active,
  .button input:active,
  .button a:active,
  .button span:active,
  .divButton button:active,
  .divButton input:active,
  .button #paymentProcessing:active,
  #btnValidateCode:active {
    border: 1px solid #cfcfcf;
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#d9d9d9),
      to(#ededed)
    );
    background-image: linear-gradient(#d9d9d9, #ededed);
  }

  .CHECKOUT input.button,
  .CHECKOUT .blackButton a,
  .CHECKOUT .button.black,
  .CHECKOUT .button input,
  .CHECKOUT .button a,
  .CHECKOUT .button span,
  .CHECKOUT .divButton button,
  .CHECKOUT .divButton input,
  .CHECKOUT .button #paymentProcessing,
  .CHECKOUT #btnValidateCode {
    background-color: var(--colour-black) !important;
    color: #fff;
  }

  .CHECKOUT input.button:hover,
  .CHECKOUT .blackButton a:hover,
  .CHECKOUT .button.black:hover,
  .CHECKOUT .button input:hover,
  .CHECKOUT .button a:hover,
  .CHECKOUT .button span:hover,
  .CHECKOUT .divButton button:hover,
  .CHECKOUT .divButton input:hover,
  .CHECKOUT .button #paymentProcessing:hover,
  .CHECKOUT #btnValidateCode:hover {
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#373737),
      to(var(--colour-black))
    );
    background-image: linear-gradient(#373737, var(--colour-black));
  }

  .CHECKOUT input.button:active,
  .CHECKOUT .blackButton a:active,
  .CHECKOUT .button.black:active,
  .CHECKOUT .button input:active,
  .CHECKOUT .button a:active,
  .CHECKOUT .button span:active,
  .CHECKOUT .divButton button:active,
  .CHECKOUT .divButton input:active,
  .CHECKOUT .button #paymentProcessing:active,
  .CHECKOUT #btnValidateCode:active {
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(var(--colour-black)),
      to(#373737)
    );
    background-image: linear-gradient(var(--colour-black), #373737);
  }

  .rightHighlight,
  .highlight,
  .submitOrder {
    border: 3px solid #e5e5e5;
    border-radius: 4px;
  }

  .rightHighlight {
    float: right;
  }

  #addToCart input,
  .rightHighlight input,
  .highlight input,
  .highlight a,
  .userAddress .Highlight input,
  .button.black {
    background-color: var(--colour-black);
    background-position: 0 0;
    border: 1px solid var(--colour-black);
    color: #fff;
  }

  #addToCart input:hover,
  .rightHighlight input:hover,
  .highlight input:hover,
  .highlight a:hover,
  .userAddress .Highlight input:hover,
  .button.black:hover {
    border: 1px solid var(--colour-black);
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#373737),
      to(var(--colour-black))
    );
    background-image: linear-gradient(#373737, var(--colour-black));
  }

  #addToCart input:active,
  .rightHighlight input:active,
  .highlight input:active,
  .highlight a:active,
  .userAddress .Highlight input:active,
  .button.black:active {
    border: 1px solid var(--colour-black);
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(var(--colour-black)),
      to(#373737)
    );
    background-image: linear-gradient(var(--colour-black), #373737);
  }

  .userAddress .Highlight input,
  .userAddress .divButton input {
    height: 20px;
  }

  .submitOrder input {
    background-color: #b30000;
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#b30000),
      to(#760000)
    );
    background-image: linear-gradient(#b30000, #760000);
    background-position: 0 0;
    border: 1px solid #5c0000;
    color: #fff;
    height: 38px;
  }

  .submitOrder input:hover {
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#c40407),
      to(#a60003)
    );
    background-image: linear-gradient(#c40407, #a60003);
    border-color: #5c0000;
    text-shadow: 0px 2px 1px #500;
  }

  .submitOrder input:active {
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#760000),
      to(#b30000)
    );
    background-image: linear-gradient(#760000, #b30000);
    border-color: #5c0000;
    text-shadow: 0px 2px 1px #500;
  }

  .button #paymentProcessing {
    line-height: 30px;
    cursor: wait;
  }

  .button #paymentProcessing:before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 6px;
    background: transparent url(../graphics/loading-EEEEEE-on-990000.gif)
      no-repeat center;
    vertical-align: middle;
  }

  .btnPayPal {
    background-color: #ffd678;
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#ffd678),
      to(#ffae34)
    );
    background-image: linear-gradient(#ffd678, #ffae34);
  }

  .btnPayPal:hover {
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#ffe09a),
      to(#ffb84d)
    );
    background-image: linear-gradient(#ffe09a, #ffb84d);
  }

  .btnPayPal:active {
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#ffae34),
      to(#ffd678)
    );
    background-image: linear-gradient(#ffae34, #ffd678);
  }

  .btnPayPal input {
    background: transparent url(../graphics/button-paypal.png) no-repeat 70px
      7px;
    border-color: #ff9b1c;
    text-transform: none;
    color: #0e529a;
    padding: 0 87px 0 9px;
  }

  .btnPayPal input:hover {
    background: transparent url(../graphics/button-paypal.png) no-repeat 70px
      7px;
    border-color: #ff9b1c;
    text-shadow: 0px 2px 1px #ffc869;
  }

  .btnPayPal input:active {
    background: transparent url(../graphics/button-paypal.png) no-repeat 70px
      7px;
    border-color: #ff9b1c;
    text-shadow: 0px 2px 1px #fda;
  }

  .standard__cta-button,
  form.return-form input[type="submit"],
  form.return-form button#submit,
  form.customer-form input[type="submit"],
  form.customer-form button#submit,
  form.profile-form input[type="submit"],
  form.profile-form button#submit,
  .pro-apply .customer-form input[type="submit"],
  .pro-apply .customer-form button#submit,
  form.newsletter-thankyou input[type="submit"],
  form.newsletter-thankyou button#submit,
  #submit.standard__cta-button input.standard__cta-button,
  form.return-form input#submit[type="submit"] input.standard__cta-button,
  form.return-form button#submit input.standard__cta-button,
  form.customer-form input#submit[type="submit"] input.standard__cta-button,
  form.customer-form button#submit input.standard__cta-button,
  form.profile-form input#submit[type="submit"] input.standard__cta-button,
  form.profile-form button#submit input.standard__cta-button,
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button,
  .pro-apply .customer-form button#submit input.standard__cta-button,
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button,
  form.newsletter-thankyou button#submit input.standard__cta-button,
  #submit.standard__cta-button form.return-form input[type="submit"],
  form.return-form #submit.standard__cta-button input[type="submit"],
  form.return-form input#submit[type="submit"] input[type="submit"],
  form.return-form button#submit input[type="submit"],
  #submit.standard__cta-button form.customer-form input[type="submit"],
  form.customer-form #submit.standard__cta-button input[type="submit"],
  form.customer-form input#submit[type="submit"] input[type="submit"],
  form.customer-form button#submit input[type="submit"],
  #submit.standard__cta-button form.profile-form input[type="submit"],
  form.profile-form #submit.standard__cta-button input[type="submit"],
  form.profile-form input#submit[type="submit"] input[type="submit"],
  form.profile-form button#submit input[type="submit"],
  #submit.standard__cta-button .pro-apply .customer-form input[type="submit"],
  .pro-apply .customer-form #submit.standard__cta-button input[type="submit"],
  .pro-apply .customer-form input#submit[type="submit"] input[type="submit"],
  .pro-apply .customer-form button#submit input[type="submit"],
  #submit.standard__cta-button form.newsletter-thankyou input[type="submit"],
  form.newsletter-thankyou #submit.standard__cta-button input[type="submit"],
  form.newsletter-thankyou input#submit[type="submit"] input[type="submit"],
  form.newsletter-thankyou button#submit input[type="submit"] {
    display: inline-block;
    position: relative;
    background: var(--colour-black);
    color: #fff;
    border-radius: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: none;
    min-height: 42px;
    min-width: 142px;
    max-width: 400px;
    height: auto;
    font-family: var(--font-helvetica) !important;
    font-size: 16px;
    padding: 6px 0;
    margin: 0 0 1.5em 0;
    text-transform: uppercase;
    cursor: pointer;
  }

  .standard__cta-button:hover,
  form.return-form input:hover[type="submit"],
  form.return-form button#submit:hover,
  form.customer-form input:hover[type="submit"],
  form.customer-form button#submit:hover,
  form.profile-form input:hover[type="submit"],
  form.profile-form button#submit:hover,
  .pro-apply .customer-form input:hover[type="submit"],
  .pro-apply .customer-form button#submit:hover,
  form.newsletter-thankyou input:hover[type="submit"],
  form.newsletter-thankyou button#submit:hover,
  #submit.standard__cta-button input.standard__cta-button:hover,
  form.return-form input#submit[type="submit"] input.standard__cta-button:hover,
  form.return-form button#submit input.standard__cta-button:hover,
  form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  form.customer-form button#submit input.standard__cta-button:hover,
  form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  form.profile-form button#submit input.standard__cta-button:hover,
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  .pro-apply .customer-form button#submit input.standard__cta-button:hover,
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  form.newsletter-thankyou button#submit input.standard__cta-button:hover,
  #submit.standard__cta-button form.return-form input:hover[type="submit"],
  form.return-form #submit.standard__cta-button input:hover[type="submit"],
  form.return-form input#submit[type="submit"] input:hover[type="submit"],
  form.return-form button#submit input:hover[type="submit"],
  #submit.standard__cta-button form.customer-form input:hover[type="submit"],
  form.customer-form #submit.standard__cta-button input:hover[type="submit"],
  form.customer-form input#submit[type="submit"] input:hover[type="submit"],
  form.customer-form button#submit input:hover[type="submit"],
  #submit.standard__cta-button form.profile-form input:hover[type="submit"],
  form.profile-form #submit.standard__cta-button input:hover[type="submit"],
  form.profile-form input#submit[type="submit"] input:hover[type="submit"],
  form.profile-form button#submit input:hover[type="submit"],
  #submit.standard__cta-button
    .pro-apply
    .customer-form
    input:hover[type="submit"],
  .pro-apply
    .customer-form
    #submit.standard__cta-button
    input:hover[type="submit"],
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input:hover[type="submit"],
  .pro-apply .customer-form button#submit input:hover[type="submit"],
  #submit.standard__cta-button
    form.newsletter-thankyou
    input:hover[type="submit"],
  form.newsletter-thankyou
    #submit.standard__cta-button
    input:hover[type="submit"],
  form.newsletter-thankyou
    input#submit[type="submit"]
    input:hover[type="submit"],
  form.newsletter-thankyou button#submit input:hover[type="submit"] {
    border: none;
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#373737),
      to(var(--colour-black))
    );
    background-image: linear-gradient(#373737, var(--colour-black));
    -webkit-transition: background-color 400ms ease-in;
    transition: background-color 400ms ease-in;
  }

  .standard__cta-button:active,
  form.return-form input:active[type="submit"],
  form.return-form button#submit:active,
  form.customer-form input:active[type="submit"],
  form.customer-form button#submit:active,
  form.profile-form input:active[type="submit"],
  form.profile-form button#submit:active,
  .pro-apply .customer-form input:active[type="submit"],
  .pro-apply .customer-form button#submit:active,
  form.newsletter-thankyou input:active[type="submit"],
  form.newsletter-thankyou button#submit:active,
  #submit.standard__cta-button input.standard__cta-button:active,
  form.return-form
    input#submit[type="submit"]
    input.standard__cta-button:active,
  form.return-form button#submit input.standard__cta-button:active,
  form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button:active,
  form.customer-form button#submit input.standard__cta-button:active,
  form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button:active,
  form.profile-form button#submit input.standard__cta-button:active,
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button:active,
  .pro-apply .customer-form button#submit input.standard__cta-button:active,
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button:active,
  form.newsletter-thankyou button#submit input.standard__cta-button:active,
  #submit.standard__cta-button form.return-form input:active[type="submit"],
  form.return-form #submit.standard__cta-button input:active[type="submit"],
  form.return-form input#submit[type="submit"] input:active[type="submit"],
  form.return-form button#submit input:active[type="submit"],
  #submit.standard__cta-button form.customer-form input:active[type="submit"],
  form.customer-form #submit.standard__cta-button input:active[type="submit"],
  form.customer-form input#submit[type="submit"] input:active[type="submit"],
  form.customer-form button#submit input:active[type="submit"],
  #submit.standard__cta-button form.profile-form input:active[type="submit"],
  form.profile-form #submit.standard__cta-button input:active[type="submit"],
  form.profile-form input#submit[type="submit"] input:active[type="submit"],
  form.profile-form button#submit input:active[type="submit"],
  #submit.standard__cta-button
    .pro-apply
    .customer-form
    input:active[type="submit"],
  .pro-apply
    .customer-form
    #submit.standard__cta-button
    input:active[type="submit"],
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input:active[type="submit"],
  .pro-apply .customer-form button#submit input:active[type="submit"],
  #submit.standard__cta-button
    form.newsletter-thankyou
    input:active[type="submit"],
  form.newsletter-thankyou
    #submit.standard__cta-button
    input:active[type="submit"],
  form.newsletter-thankyou
    input#submit[type="submit"]
    input:active[type="submit"],
  form.newsletter-thankyou button#submit input:active[type="submit"] {
    border: none;
    text-decoration: none !important;
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(var(--colour-black)),
      to(#373737)
    );
    background-image: linear-gradient(var(--colour-black), #373737);
    -webkit-transition: background-color 400ms ease-in;
    transition: background-color 400ms ease-in;
  }

  .standard__cta-button:disabled,
  form.return-form input:disabled[type="submit"],
  form.return-form button#submit:disabled,
  form.customer-form input:disabled[type="submit"],
  form.customer-form button#submit:disabled,
  form.profile-form input:disabled[type="submit"],
  form.profile-form button#submit:disabled,
  .pro-apply .customer-form input:disabled[type="submit"],
  .pro-apply .customer-form button#submit:disabled,
  form.newsletter-thankyou input:disabled[type="submit"],
  form.newsletter-thankyou button#submit:disabled,
  #submit.standard__cta-button input.standard__cta-button:disabled,
  form.return-form
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  form.return-form button#submit input.standard__cta-button:disabled,
  form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  form.customer-form button#submit input.standard__cta-button:disabled,
  form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  form.profile-form button#submit input.standard__cta-button:disabled,
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  .pro-apply .customer-form button#submit input.standard__cta-button:disabled,
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  form.newsletter-thankyou button#submit input.standard__cta-button:disabled,
  #submit.standard__cta-button form.return-form input:disabled[type="submit"],
  form.return-form #submit.standard__cta-button input:disabled[type="submit"],
  form.return-form input#submit[type="submit"] input:disabled[type="submit"],
  form.return-form button#submit input:disabled[type="submit"],
  #submit.standard__cta-button form.customer-form input:disabled[type="submit"],
  form.customer-form #submit.standard__cta-button input:disabled[type="submit"],
  form.customer-form input#submit[type="submit"] input:disabled[type="submit"],
  form.customer-form button#submit input:disabled[type="submit"],
  #submit.standard__cta-button form.profile-form input:disabled[type="submit"],
  form.profile-form #submit.standard__cta-button input:disabled[type="submit"],
  form.profile-form input#submit[type="submit"] input:disabled[type="submit"],
  form.profile-form button#submit input:disabled[type="submit"],
  #submit.standard__cta-button
    .pro-apply
    .customer-form
    input:disabled[type="submit"],
  .pro-apply
    .customer-form
    #submit.standard__cta-button
    input:disabled[type="submit"],
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input:disabled[type="submit"],
  .pro-apply .customer-form button#submit input:disabled[type="submit"],
  #submit.standard__cta-button
    form.newsletter-thankyou
    input:disabled[type="submit"],
  form.newsletter-thankyou
    #submit.standard__cta-button
    input:disabled[type="submit"],
  form.newsletter-thankyou
    input#submit[type="submit"]
    input:disabled[type="submit"],
  form.newsletter-thankyou button#submit input:disabled[type="submit"] {
    opacity: 0.3;
    color: #ccc;
    cursor: default;
    cursor: not-allowed;
  }

  .URBAN .standard__cta-button,
  .URBAN form.return-form input[type="submit"],
  form.return-form .URBAN input[type="submit"],
  .URBAN form.return-form button#submit,
  form.return-form .URBAN button#submit,
  .URBAN form.customer-form input[type="submit"],
  form.customer-form .URBAN input[type="submit"],
  .URBAN form.customer-form button#submit,
  form.customer-form .URBAN button#submit,
  .URBAN form.profile-form input[type="submit"],
  form.profile-form .URBAN input[type="submit"],
  .URBAN form.profile-form button#submit,
  form.profile-form .URBAN button#submit,
  .URBAN .pro-apply .customer-form input[type="submit"],
  .pro-apply .customer-form .URBAN input[type="submit"],
  .URBAN .pro-apply .customer-form button#submit,
  .pro-apply .customer-form .URBAN button#submit,
  .URBAN form.newsletter-thankyou input[type="submit"],
  form.newsletter-thankyou .URBAN input[type="submit"],
  .URBAN form.newsletter-thankyou button#submit,
  form.newsletter-thankyou .URBAN button#submit,
  .URBAN #submit.standard__cta-button input.standard__cta-button,
  .URBAN
    form.return-form
    input#submit[type="submit"]
    input.standard__cta-button,
  form.return-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button,
  .URBAN form.return-form button#submit input.standard__cta-button,
  form.return-form .URBAN button#submit input.standard__cta-button,
  .URBAN
    form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button,
  form.customer-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button,
  .URBAN form.customer-form button#submit input.standard__cta-button,
  form.customer-form .URBAN button#submit input.standard__cta-button,
  .URBAN
    form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button,
  form.profile-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button,
  .URBAN form.profile-form button#submit input.standard__cta-button,
  form.profile-form .URBAN button#submit input.standard__cta-button,
  .URBAN
    .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button,
  .pro-apply
    .customer-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button,
  .URBAN .pro-apply .customer-form button#submit input.standard__cta-button,
  .pro-apply .customer-form .URBAN button#submit input.standard__cta-button,
  .URBAN
    form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button,
  form.newsletter-thankyou
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button,
  .URBAN form.newsletter-thankyou button#submit input.standard__cta-button,
  form.newsletter-thankyou .URBAN button#submit input.standard__cta-button,
  .URBAN #submit.standard__cta-button form.return-form input[type="submit"],
  form.return-form .URBAN #submit.standard__cta-button input[type="submit"],
  .URBAN form.return-form input#submit[type="submit"] input[type="submit"],
  form.return-form .URBAN input#submit[type="submit"] input[type="submit"],
  .URBAN form.return-form button#submit input[type="submit"],
  form.return-form .URBAN button#submit input[type="submit"],
  .URBAN #submit.standard__cta-button form.customer-form input[type="submit"],
  form.customer-form .URBAN #submit.standard__cta-button input[type="submit"],
  .URBAN form.customer-form input#submit[type="submit"] input[type="submit"],
  form.customer-form .URBAN input#submit[type="submit"] input[type="submit"],
  .URBAN form.customer-form button#submit input[type="submit"],
  form.customer-form .URBAN button#submit input[type="submit"],
  .URBAN #submit.standard__cta-button form.profile-form input[type="submit"],
  form.profile-form .URBAN #submit.standard__cta-button input[type="submit"],
  .URBAN form.profile-form input#submit[type="submit"] input[type="submit"],
  form.profile-form .URBAN input#submit[type="submit"] input[type="submit"],
  .URBAN form.profile-form button#submit input[type="submit"],
  form.profile-form .URBAN button#submit input[type="submit"],
  .URBAN
    #submit.standard__cta-button
    .pro-apply
    .customer-form
    input[type="submit"],
  .pro-apply
    .customer-form
    .URBAN
    #submit.standard__cta-button
    input[type="submit"],
  .URBAN
    .pro-apply
    .customer-form
    input#submit[type="submit"]
    input[type="submit"],
  .pro-apply
    .customer-form
    .URBAN
    input#submit[type="submit"]
    input[type="submit"],
  .URBAN .pro-apply .customer-form button#submit input[type="submit"],
  .pro-apply .customer-form .URBAN button#submit input[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.newsletter-thankyou
    input[type="submit"],
  form.newsletter-thankyou
    .URBAN
    #submit.standard__cta-button
    input[type="submit"],
  .URBAN
    form.newsletter-thankyou
    input#submit[type="submit"]
    input[type="submit"],
  form.newsletter-thankyou
    .URBAN
    input#submit[type="submit"]
    input[type="submit"],
  .URBAN form.newsletter-thankyou button#submit input[type="submit"],
  form.newsletter-thankyou .URBAN button#submit input[type="submit"] {
    background: #fff;
    color: #262626 !important;
    border: 1px solid #262626;
  }

  .URBAN .standard__cta-button:hover,
  .URBAN form.return-form input:hover[type="submit"],
  form.return-form .URBAN input:hover[type="submit"],
  .URBAN form.return-form button#submit:hover,
  form.return-form .URBAN button#submit:hover,
  .URBAN form.customer-form input:hover[type="submit"],
  form.customer-form .URBAN input:hover[type="submit"],
  .URBAN form.customer-form button#submit:hover,
  form.customer-form .URBAN button#submit:hover,
  .URBAN form.profile-form input:hover[type="submit"],
  form.profile-form .URBAN input:hover[type="submit"],
  .URBAN form.profile-form button#submit:hover,
  form.profile-form .URBAN button#submit:hover,
  .URBAN .pro-apply .customer-form input:hover[type="submit"],
  .pro-apply .customer-form .URBAN input:hover[type="submit"],
  .URBAN .pro-apply .customer-form button#submit:hover,
  .pro-apply .customer-form .URBAN button#submit:hover,
  .URBAN form.newsletter-thankyou input:hover[type="submit"],
  form.newsletter-thankyou .URBAN input:hover[type="submit"],
  .URBAN form.newsletter-thankyou button#submit:hover,
  form.newsletter-thankyou .URBAN button#submit:hover,
  .URBAN .standard__cta-button:active,
  .URBAN form.return-form input:active[type="submit"],
  form.return-form .URBAN input:active[type="submit"],
  .URBAN form.return-form button#submit:active,
  form.return-form .URBAN button#submit:active,
  .URBAN form.customer-form input:active[type="submit"],
  form.customer-form .URBAN input:active[type="submit"],
  .URBAN form.customer-form button#submit:active,
  form.customer-form .URBAN button#submit:active,
  .URBAN form.profile-form input:active[type="submit"],
  form.profile-form .URBAN input:active[type="submit"],
  .URBAN form.profile-form button#submit:active,
  form.profile-form .URBAN button#submit:active,
  .URBAN .pro-apply .customer-form input:active[type="submit"],
  .pro-apply .customer-form .URBAN input:active[type="submit"],
  .URBAN .pro-apply .customer-form button#submit:active,
  .pro-apply .customer-form .URBAN button#submit:active,
  .URBAN form.newsletter-thankyou input:active[type="submit"],
  form.newsletter-thankyou .URBAN input:active[type="submit"],
  .URBAN form.newsletter-thankyou button#submit:active,
  form.newsletter-thankyou .URBAN button#submit:active,
  .URBAN #submit.standard__cta-button input.standard__cta-button:hover,
  .URBAN
    form.return-form
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  form.return-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  .URBAN form.return-form button#submit input.standard__cta-button:hover,
  form.return-form .URBAN button#submit input.standard__cta-button:hover,
  .URBAN
    form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  form.customer-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  .URBAN form.customer-form button#submit input.standard__cta-button:hover,
  form.customer-form .URBAN button#submit input.standard__cta-button:hover,
  .URBAN
    form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  form.profile-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  .URBAN form.profile-form button#submit input.standard__cta-button:hover,
  form.profile-form .URBAN button#submit input.standard__cta-button:hover,
  .URBAN
    .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  .pro-apply
    .customer-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  .URBAN
    .pro-apply
    .customer-form
    button#submit
    input.standard__cta-button:hover,
  .pro-apply
    .customer-form
    .URBAN
    button#submit
    input.standard__cta-button:hover,
  .URBAN
    form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  form.newsletter-thankyou
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:hover,
  .URBAN
    form.newsletter-thankyou
    button#submit
    input.standard__cta-button:hover,
  form.newsletter-thankyou
    .URBAN
    button#submit
    input.standard__cta-button:hover,
  .URBAN
    #submit.standard__cta-button
    form.return-form
    input:hover[type="submit"],
  form.return-form
    .URBAN
    #submit.standard__cta-button
    input:hover[type="submit"],
  .URBAN
    form.return-form
    input#submit[type="submit"]
    input:hover[type="submit"],
  form.return-form
    .URBAN
    input#submit[type="submit"]
    input:hover[type="submit"],
  .URBAN form.return-form button#submit input:hover[type="submit"],
  form.return-form .URBAN button#submit input:hover[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.customer-form
    input:hover[type="submit"],
  form.customer-form
    .URBAN
    #submit.standard__cta-button
    input:hover[type="submit"],
  .URBAN
    form.customer-form
    input#submit[type="submit"]
    input:hover[type="submit"],
  form.customer-form
    .URBAN
    input#submit[type="submit"]
    input:hover[type="submit"],
  .URBAN form.customer-form button#submit input:hover[type="submit"],
  form.customer-form .URBAN button#submit input:hover[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.profile-form
    input:hover[type="submit"],
  form.profile-form
    .URBAN
    #submit.standard__cta-button
    input:hover[type="submit"],
  .URBAN
    form.profile-form
    input#submit[type="submit"]
    input:hover[type="submit"],
  form.profile-form
    .URBAN
    input#submit[type="submit"]
    input:hover[type="submit"],
  .URBAN form.profile-form button#submit input:hover[type="submit"],
  form.profile-form .URBAN button#submit input:hover[type="submit"],
  .URBAN
    #submit.standard__cta-button
    .pro-apply
    .customer-form
    input:hover[type="submit"],
  .pro-apply
    .customer-form
    .URBAN
    #submit.standard__cta-button
    input:hover[type="submit"],
  .URBAN
    .pro-apply
    .customer-form
    input#submit[type="submit"]
    input:hover[type="submit"],
  .pro-apply
    .customer-form
    .URBAN
    input#submit[type="submit"]
    input:hover[type="submit"],
  .URBAN .pro-apply .customer-form button#submit input:hover[type="submit"],
  .pro-apply .customer-form .URBAN button#submit input:hover[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.newsletter-thankyou
    input:hover[type="submit"],
  form.newsletter-thankyou
    .URBAN
    #submit.standard__cta-button
    input:hover[type="submit"],
  .URBAN
    form.newsletter-thankyou
    input#submit[type="submit"]
    input:hover[type="submit"],
  form.newsletter-thankyou
    .URBAN
    input#submit[type="submit"]
    input:hover[type="submit"],
  .URBAN form.newsletter-thankyou button#submit input:hover[type="submit"],
  form.newsletter-thankyou .URBAN button#submit input:hover[type="submit"],
  .URBAN #submit.standard__cta-button input.standard__cta-button:active,
  .URBAN
    form.return-form
    input#submit[type="submit"]
    input.standard__cta-button:active,
  form.return-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:active,
  .URBAN form.return-form button#submit input.standard__cta-button:active,
  form.return-form .URBAN button#submit input.standard__cta-button:active,
  .URBAN
    form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button:active,
  form.customer-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:active,
  .URBAN form.customer-form button#submit input.standard__cta-button:active,
  form.customer-form .URBAN button#submit input.standard__cta-button:active,
  .URBAN
    form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button:active,
  form.profile-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:active,
  .URBAN form.profile-form button#submit input.standard__cta-button:active,
  form.profile-form .URBAN button#submit input.standard__cta-button:active,
  .URBAN
    .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button:active,
  .pro-apply
    .customer-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:active,
  .URBAN
    .pro-apply
    .customer-form
    button#submit
    input.standard__cta-button:active,
  .pro-apply
    .customer-form
    .URBAN
    button#submit
    input.standard__cta-button:active,
  .URBAN
    form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button:active,
  form.newsletter-thankyou
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:active,
  .URBAN
    form.newsletter-thankyou
    button#submit
    input.standard__cta-button:active,
  form.newsletter-thankyou
    .URBAN
    button#submit
    input.standard__cta-button:active,
  .URBAN
    #submit.standard__cta-button
    form.return-form
    input:active[type="submit"],
  form.return-form
    .URBAN
    #submit.standard__cta-button
    input:active[type="submit"],
  .URBAN
    form.return-form
    input#submit[type="submit"]
    input:active[type="submit"],
  form.return-form
    .URBAN
    input#submit[type="submit"]
    input:active[type="submit"],
  .URBAN form.return-form button#submit input:active[type="submit"],
  form.return-form .URBAN button#submit input:active[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.customer-form
    input:active[type="submit"],
  form.customer-form
    .URBAN
    #submit.standard__cta-button
    input:active[type="submit"],
  .URBAN
    form.customer-form
    input#submit[type="submit"]
    input:active[type="submit"],
  form.customer-form
    .URBAN
    input#submit[type="submit"]
    input:active[type="submit"],
  .URBAN form.customer-form button#submit input:active[type="submit"],
  form.customer-form .URBAN button#submit input:active[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.profile-form
    input:active[type="submit"],
  form.profile-form
    .URBAN
    #submit.standard__cta-button
    input:active[type="submit"],
  .URBAN
    form.profile-form
    input#submit[type="submit"]
    input:active[type="submit"],
  form.profile-form
    .URBAN
    input#submit[type="submit"]
    input:active[type="submit"],
  .URBAN form.profile-form button#submit input:active[type="submit"],
  form.profile-form .URBAN button#submit input:active[type="submit"],
  .URBAN
    #submit.standard__cta-button
    .pro-apply
    .customer-form
    input:active[type="submit"],
  .pro-apply
    .customer-form
    .URBAN
    #submit.standard__cta-button
    input:active[type="submit"],
  .URBAN
    .pro-apply
    .customer-form
    input#submit[type="submit"]
    input:active[type="submit"],
  .pro-apply
    .customer-form
    .URBAN
    input#submit[type="submit"]
    input:active[type="submit"],
  .URBAN .pro-apply .customer-form button#submit input:active[type="submit"],
  .pro-apply .customer-form .URBAN button#submit input:active[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.newsletter-thankyou
    input:active[type="submit"],
  form.newsletter-thankyou
    .URBAN
    #submit.standard__cta-button
    input:active[type="submit"],
  .URBAN
    form.newsletter-thankyou
    input#submit[type="submit"]
    input:active[type="submit"],
  form.newsletter-thankyou
    .URBAN
    input#submit[type="submit"]
    input:active[type="submit"],
  .URBAN form.newsletter-thankyou button#submit input:active[type="submit"],
  form.newsletter-thankyou .URBAN button#submit input:active[type="submit"] {
    background-color: #262626;
    color: #fff !important;
    text-decoration: none !important;
    -webkit-transition: background-color 400ms ease-in;
    transition: background-color 400ms ease-in;
  }

  .URBAN .standard__cta-button:disabled,
  .URBAN form.return-form input:disabled[type="submit"],
  form.return-form .URBAN input:disabled[type="submit"],
  .URBAN form.return-form button#submit:disabled,
  form.return-form .URBAN button#submit:disabled,
  .URBAN form.customer-form input:disabled[type="submit"],
  form.customer-form .URBAN input:disabled[type="submit"],
  .URBAN form.customer-form button#submit:disabled,
  form.customer-form .URBAN button#submit:disabled,
  .URBAN form.profile-form input:disabled[type="submit"],
  form.profile-form .URBAN input:disabled[type="submit"],
  .URBAN form.profile-form button#submit:disabled,
  form.profile-form .URBAN button#submit:disabled,
  .URBAN .pro-apply .customer-form input:disabled[type="submit"],
  .pro-apply .customer-form .URBAN input:disabled[type="submit"],
  .URBAN .pro-apply .customer-form button#submit:disabled,
  .pro-apply .customer-form .URBAN button#submit:disabled,
  .URBAN form.newsletter-thankyou input:disabled[type="submit"],
  form.newsletter-thankyou .URBAN input:disabled[type="submit"],
  .URBAN form.newsletter-thankyou button#submit:disabled,
  form.newsletter-thankyou .URBAN button#submit:disabled,
  .URBAN #submit.standard__cta-button input.standard__cta-button:disabled,
  .URBAN
    form.return-form
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  form.return-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  .URBAN form.return-form button#submit input.standard__cta-button:disabled,
  form.return-form .URBAN button#submit input.standard__cta-button:disabled,
  .URBAN
    form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  form.customer-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  .URBAN form.customer-form button#submit input.standard__cta-button:disabled,
  form.customer-form .URBAN button#submit input.standard__cta-button:disabled,
  .URBAN
    form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  form.profile-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  .URBAN form.profile-form button#submit input.standard__cta-button:disabled,
  form.profile-form .URBAN button#submit input.standard__cta-button:disabled,
  .URBAN
    .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  .pro-apply
    .customer-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  .URBAN
    .pro-apply
    .customer-form
    button#submit
    input.standard__cta-button:disabled,
  .pro-apply
    .customer-form
    .URBAN
    button#submit
    input.standard__cta-button:disabled,
  .URBAN
    form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  form.newsletter-thankyou
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  .URBAN
    form.newsletter-thankyou
    button#submit
    input.standard__cta-button:disabled,
  form.newsletter-thankyou
    .URBAN
    button#submit
    input.standard__cta-button:disabled,
  .URBAN
    #submit.standard__cta-button
    form.return-form
    input:disabled[type="submit"],
  form.return-form
    .URBAN
    #submit.standard__cta-button
    input:disabled[type="submit"],
  .URBAN
    form.return-form
    input#submit[type="submit"]
    input:disabled[type="submit"],
  form.return-form
    .URBAN
    input#submit[type="submit"]
    input:disabled[type="submit"],
  .URBAN form.return-form button#submit input:disabled[type="submit"],
  form.return-form .URBAN button#submit input:disabled[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.customer-form
    input:disabled[type="submit"],
  form.customer-form
    .URBAN
    #submit.standard__cta-button
    input:disabled[type="submit"],
  .URBAN
    form.customer-form
    input#submit[type="submit"]
    input:disabled[type="submit"],
  form.customer-form
    .URBAN
    input#submit[type="submit"]
    input:disabled[type="submit"],
  .URBAN form.customer-form button#submit input:disabled[type="submit"],
  form.customer-form .URBAN button#submit input:disabled[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.profile-form
    input:disabled[type="submit"],
  form.profile-form
    .URBAN
    #submit.standard__cta-button
    input:disabled[type="submit"],
  .URBAN
    form.profile-form
    input#submit[type="submit"]
    input:disabled[type="submit"],
  form.profile-form
    .URBAN
    input#submit[type="submit"]
    input:disabled[type="submit"],
  .URBAN form.profile-form button#submit input:disabled[type="submit"],
  form.profile-form .URBAN button#submit input:disabled[type="submit"],
  .URBAN
    #submit.standard__cta-button
    .pro-apply
    .customer-form
    input:disabled[type="submit"],
  .pro-apply
    .customer-form
    .URBAN
    #submit.standard__cta-button
    input:disabled[type="submit"],
  .URBAN
    .pro-apply
    .customer-form
    input#submit[type="submit"]
    input:disabled[type="submit"],
  .pro-apply
    .customer-form
    .URBAN
    input#submit[type="submit"]
    input:disabled[type="submit"],
  .URBAN .pro-apply .customer-form button#submit input:disabled[type="submit"],
  .pro-apply .customer-form .URBAN button#submit input:disabled[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.newsletter-thankyou
    input:disabled[type="submit"],
  form.newsletter-thankyou
    .URBAN
    #submit.standard__cta-button
    input:disabled[type="submit"],
  .URBAN
    form.newsletter-thankyou
    input#submit[type="submit"]
    input:disabled[type="submit"],
  form.newsletter-thankyou
    .URBAN
    input#submit[type="submit"]
    input:disabled[type="submit"],
  .URBAN form.newsletter-thankyou button#submit input:disabled[type="submit"],
  form.newsletter-thankyou .URBAN button#submit input:disabled[type="submit"] {
    opacity: 0.5;
    color: #aaa !important;
    cursor: default;
    cursor: not-allowed;
    border-color: #aaa;
  }

  .standard__cta-button.cta-button--disabled,
  form.return-form input.cta-button--disabled[type="submit"],
  form.return-form button.cta-button--disabled#submit,
  form.customer-form input.cta-button--disabled[type="submit"],
  form.customer-form button.cta-button--disabled#submit,
  form.profile-form input.cta-button--disabled[type="submit"],
  form.profile-form button.cta-button--disabled#submit,
  .pro-apply .customer-form input.cta-button--disabled[type="submit"],
  .pro-apply .customer-form button.cta-button--disabled#submit,
  form.newsletter-thankyou input.cta-button--disabled[type="submit"],
  form.newsletter-thankyou button.cta-button--disabled#submit,
  #submit.standard__cta-button input.standard__cta-button.cta-button--disabled,
  form.return-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  form.return-form
    button#submit
    input.standard__cta-button.cta-button--disabled,
  form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  form.customer-form
    button#submit
    input.standard__cta-button.cta-button--disabled,
  form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  form.profile-form
    button#submit
    input.standard__cta-button.cta-button--disabled,
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  .pro-apply
    .customer-form
    button#submit
    input.standard__cta-button.cta-button--disabled,
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  form.newsletter-thankyou
    button#submit
    input.standard__cta-button.cta-button--disabled,
  #submit.standard__cta-button
    form.return-form
    input.cta-button--disabled[type="submit"],
  form.return-form
    #submit.standard__cta-button
    input.cta-button--disabled[type="submit"],
  form.return-form
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  form.return-form button#submit input.cta-button--disabled[type="submit"],
  #submit.standard__cta-button
    form.customer-form
    input.cta-button--disabled[type="submit"],
  form.customer-form
    #submit.standard__cta-button
    input.cta-button--disabled[type="submit"],
  form.customer-form
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  form.customer-form button#submit input.cta-button--disabled[type="submit"],
  #submit.standard__cta-button
    form.profile-form
    input.cta-button--disabled[type="submit"],
  form.profile-form
    #submit.standard__cta-button
    input.cta-button--disabled[type="submit"],
  form.profile-form
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  form.profile-form button#submit input.cta-button--disabled[type="submit"],
  #submit.standard__cta-button
    .pro-apply
    .customer-form
    input.cta-button--disabled[type="submit"],
  .pro-apply
    .customer-form
    #submit.standard__cta-button
    input.cta-button--disabled[type="submit"],
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  .pro-apply
    .customer-form
    button#submit
    input.cta-button--disabled[type="submit"],
  #submit.standard__cta-button
    form.newsletter-thankyou
    input.cta-button--disabled[type="submit"],
  form.newsletter-thankyou
    #submit.standard__cta-button
    input.cta-button--disabled[type="submit"],
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  form.newsletter-thankyou
    button#submit
    input.cta-button--disabled[type="submit"] {
    opacity: 0.3;
    color: #ccc;
    cursor: default;
    cursor: not-allowed;
  }

  .standard__cta-button.cta-button--disabled:hover,
  form.return-form input.cta-button--disabled:hover[type="submit"],
  form.return-form button.cta-button--disabled#submit:hover,
  form.customer-form input.cta-button--disabled:hover[type="submit"],
  form.customer-form button.cta-button--disabled#submit:hover,
  form.profile-form input.cta-button--disabled:hover[type="submit"],
  form.profile-form button.cta-button--disabled#submit:hover,
  .pro-apply .customer-form input.cta-button--disabled:hover[type="submit"],
  .pro-apply .customer-form button.cta-button--disabled#submit:hover,
  form.newsletter-thankyou input.cta-button--disabled:hover[type="submit"],
  form.newsletter-thankyou button.cta-button--disabled#submit:hover,
  .standard__cta-button.cta-button--disabled:active,
  form.return-form input.cta-button--disabled:active[type="submit"],
  form.return-form button.cta-button--disabled#submit:active,
  form.customer-form input.cta-button--disabled:active[type="submit"],
  form.customer-form button.cta-button--disabled#submit:active,
  form.profile-form input.cta-button--disabled:active[type="submit"],
  form.profile-form button.cta-button--disabled#submit:active,
  .pro-apply .customer-form input.cta-button--disabled:active[type="submit"],
  .pro-apply .customer-form button.cta-button--disabled#submit:active,
  form.newsletter-thankyou input.cta-button--disabled:active[type="submit"],
  form.newsletter-thankyou button.cta-button--disabled#submit:active,
  #submit.standard__cta-button
    input.standard__cta-button.cta-button--disabled:hover,
  form.return-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled:hover,
  form.return-form
    button#submit
    input.standard__cta-button.cta-button--disabled:hover,
  form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled:hover,
  form.customer-form
    button#submit
    input.standard__cta-button.cta-button--disabled:hover,
  form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled:hover,
  form.profile-form
    button#submit
    input.standard__cta-button.cta-button--disabled:hover,
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled:hover,
  .pro-apply
    .customer-form
    button#submit
    input.standard__cta-button.cta-button--disabled:hover,
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled:hover,
  form.newsletter-thankyou
    button#submit
    input.standard__cta-button.cta-button--disabled:hover,
  #submit.standard__cta-button
    form.return-form
    input.cta-button--disabled:hover[type="submit"],
  form.return-form
    #submit.standard__cta-button
    input.cta-button--disabled:hover[type="submit"],
  form.return-form
    input#submit[type="submit"]
    input.cta-button--disabled:hover[type="submit"],
  form.return-form
    button#submit
    input.cta-button--disabled:hover[type="submit"],
  #submit.standard__cta-button
    form.customer-form
    input.cta-button--disabled:hover[type="submit"],
  form.customer-form
    #submit.standard__cta-button
    input.cta-button--disabled:hover[type="submit"],
  form.customer-form
    input#submit[type="submit"]
    input.cta-button--disabled:hover[type="submit"],
  form.customer-form
    button#submit
    input.cta-button--disabled:hover[type="submit"],
  #submit.standard__cta-button
    form.profile-form
    input.cta-button--disabled:hover[type="submit"],
  form.profile-form
    #submit.standard__cta-button
    input.cta-button--disabled:hover[type="submit"],
  form.profile-form
    input#submit[type="submit"]
    input.cta-button--disabled:hover[type="submit"],
  form.profile-form
    button#submit
    input.cta-button--disabled:hover[type="submit"],
  #submit.standard__cta-button
    .pro-apply
    .customer-form
    input.cta-button--disabled:hover[type="submit"],
  .pro-apply
    .customer-form
    #submit.standard__cta-button
    input.cta-button--disabled:hover[type="submit"],
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.cta-button--disabled:hover[type="submit"],
  .pro-apply
    .customer-form
    button#submit
    input.cta-button--disabled:hover[type="submit"],
  #submit.standard__cta-button
    form.newsletter-thankyou
    input.cta-button--disabled:hover[type="submit"],
  form.newsletter-thankyou
    #submit.standard__cta-button
    input.cta-button--disabled:hover[type="submit"],
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.cta-button--disabled:hover[type="submit"],
  form.newsletter-thankyou
    button#submit
    input.cta-button--disabled:hover[type="submit"],
  #submit.standard__cta-button
    input.standard__cta-button.cta-button--disabled:active,
  form.return-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled:active,
  form.return-form
    button#submit
    input.standard__cta-button.cta-button--disabled:active,
  form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled:active,
  form.customer-form
    button#submit
    input.standard__cta-button.cta-button--disabled:active,
  form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled:active,
  form.profile-form
    button#submit
    input.standard__cta-button.cta-button--disabled:active,
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled:active,
  .pro-apply
    .customer-form
    button#submit
    input.standard__cta-button.cta-button--disabled:active,
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled:active,
  form.newsletter-thankyou
    button#submit
    input.standard__cta-button.cta-button--disabled:active,
  #submit.standard__cta-button
    form.return-form
    input.cta-button--disabled:active[type="submit"],
  form.return-form
    #submit.standard__cta-button
    input.cta-button--disabled:active[type="submit"],
  form.return-form
    input#submit[type="submit"]
    input.cta-button--disabled:active[type="submit"],
  form.return-form
    button#submit
    input.cta-button--disabled:active[type="submit"],
  #submit.standard__cta-button
    form.customer-form
    input.cta-button--disabled:active[type="submit"],
  form.customer-form
    #submit.standard__cta-button
    input.cta-button--disabled:active[type="submit"],
  form.customer-form
    input#submit[type="submit"]
    input.cta-button--disabled:active[type="submit"],
  form.customer-form
    button#submit
    input.cta-button--disabled:active[type="submit"],
  #submit.standard__cta-button
    form.profile-form
    input.cta-button--disabled:active[type="submit"],
  form.profile-form
    #submit.standard__cta-button
    input.cta-button--disabled:active[type="submit"],
  form.profile-form
    input#submit[type="submit"]
    input.cta-button--disabled:active[type="submit"],
  form.profile-form
    button#submit
    input.cta-button--disabled:active[type="submit"],
  #submit.standard__cta-button
    .pro-apply
    .customer-form
    input.cta-button--disabled:active[type="submit"],
  .pro-apply
    .customer-form
    #submit.standard__cta-button
    input.cta-button--disabled:active[type="submit"],
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.cta-button--disabled:active[type="submit"],
  .pro-apply
    .customer-form
    button#submit
    input.cta-button--disabled:active[type="submit"],
  #submit.standard__cta-button
    form.newsletter-thankyou
    input.cta-button--disabled:active[type="submit"],
  form.newsletter-thankyou
    #submit.standard__cta-button
    input.cta-button--disabled:active[type="submit"],
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.cta-button--disabled:active[type="submit"],
  form.newsletter-thankyou
    button#submit
    input.cta-button--disabled:active[type="submit"] {
    background: var(--colour-black);
  }

  .URBAN .standard__cta-button.cta-button--disabled,
  .URBAN form.return-form input.cta-button--disabled[type="submit"],
  form.return-form .URBAN input.cta-button--disabled[type="submit"],
  .URBAN form.return-form button.cta-button--disabled#submit,
  form.return-form .URBAN button.cta-button--disabled#submit,
  .URBAN form.customer-form input.cta-button--disabled[type="submit"],
  form.customer-form .URBAN input.cta-button--disabled[type="submit"],
  .URBAN form.customer-form button.cta-button--disabled#submit,
  form.customer-form .URBAN button.cta-button--disabled#submit,
  .URBAN form.profile-form input.cta-button--disabled[type="submit"],
  form.profile-form .URBAN input.cta-button--disabled[type="submit"],
  .URBAN form.profile-form button.cta-button--disabled#submit,
  form.profile-form .URBAN button.cta-button--disabled#submit,
  .URBAN .pro-apply .customer-form input.cta-button--disabled[type="submit"],
  .pro-apply .customer-form .URBAN input.cta-button--disabled[type="submit"],
  .URBAN .pro-apply .customer-form button.cta-button--disabled#submit,
  .pro-apply .customer-form .URBAN button.cta-button--disabled#submit,
  .URBAN form.newsletter-thankyou input.cta-button--disabled[type="submit"],
  form.newsletter-thankyou .URBAN input.cta-button--disabled[type="submit"],
  .URBAN form.newsletter-thankyou button.cta-button--disabled#submit,
  form.newsletter-thankyou .URBAN button.cta-button--disabled#submit,
  .URBAN
    #submit.standard__cta-button
    input.standard__cta-button.cta-button--disabled,
  .URBAN
    form.return-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  form.return-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  .URBAN
    form.return-form
    button#submit
    input.standard__cta-button.cta-button--disabled,
  form.return-form
    .URBAN
    button#submit
    input.standard__cta-button.cta-button--disabled,
  .URBAN
    form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  form.customer-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  .URBAN
    form.customer-form
    button#submit
    input.standard__cta-button.cta-button--disabled,
  form.customer-form
    .URBAN
    button#submit
    input.standard__cta-button.cta-button--disabled,
  .URBAN
    form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  form.profile-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  .URBAN
    form.profile-form
    button#submit
    input.standard__cta-button.cta-button--disabled,
  form.profile-form
    .URBAN
    button#submit
    input.standard__cta-button.cta-button--disabled,
  .URBAN
    .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  .pro-apply
    .customer-form
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  .URBAN
    .pro-apply
    .customer-form
    button#submit
    input.standard__cta-button.cta-button--disabled,
  .pro-apply
    .customer-form
    .URBAN
    button#submit
    input.standard__cta-button.cta-button--disabled,
  .URBAN
    form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  form.newsletter-thankyou
    .URBAN
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--disabled,
  .URBAN
    form.newsletter-thankyou
    button#submit
    input.standard__cta-button.cta-button--disabled,
  form.newsletter-thankyou
    .URBAN
    button#submit
    input.standard__cta-button.cta-button--disabled,
  .URBAN
    #submit.standard__cta-button
    form.return-form
    input.cta-button--disabled[type="submit"],
  form.return-form
    .URBAN
    #submit.standard__cta-button
    input.cta-button--disabled[type="submit"],
  .URBAN
    form.return-form
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  form.return-form
    .URBAN
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  .URBAN
    form.return-form
    button#submit
    input.cta-button--disabled[type="submit"],
  form.return-form
    .URBAN
    button#submit
    input.cta-button--disabled[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.customer-form
    input.cta-button--disabled[type="submit"],
  form.customer-form
    .URBAN
    #submit.standard__cta-button
    input.cta-button--disabled[type="submit"],
  .URBAN
    form.customer-form
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  form.customer-form
    .URBAN
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  .URBAN
    form.customer-form
    button#submit
    input.cta-button--disabled[type="submit"],
  form.customer-form
    .URBAN
    button#submit
    input.cta-button--disabled[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.profile-form
    input.cta-button--disabled[type="submit"],
  form.profile-form
    .URBAN
    #submit.standard__cta-button
    input.cta-button--disabled[type="submit"],
  .URBAN
    form.profile-form
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  form.profile-form
    .URBAN
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  .URBAN
    form.profile-form
    button#submit
    input.cta-button--disabled[type="submit"],
  form.profile-form
    .URBAN
    button#submit
    input.cta-button--disabled[type="submit"],
  .URBAN
    #submit.standard__cta-button
    .pro-apply
    .customer-form
    input.cta-button--disabled[type="submit"],
  .pro-apply
    .customer-form
    .URBAN
    #submit.standard__cta-button
    input.cta-button--disabled[type="submit"],
  .URBAN
    .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  .pro-apply
    .customer-form
    .URBAN
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  .URBAN
    .pro-apply
    .customer-form
    button#submit
    input.cta-button--disabled[type="submit"],
  .pro-apply
    .customer-form
    .URBAN
    button#submit
    input.cta-button--disabled[type="submit"],
  .URBAN
    #submit.standard__cta-button
    form.newsletter-thankyou
    input.cta-button--disabled[type="submit"],
  form.newsletter-thankyou
    .URBAN
    #submit.standard__cta-button
    input.cta-button--disabled[type="submit"],
  .URBAN
    form.newsletter-thankyou
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  form.newsletter-thankyou
    .URBAN
    input#submit[type="submit"]
    input.cta-button--disabled[type="submit"],
  .URBAN
    form.newsletter-thankyou
    button#submit
    input.cta-button--disabled[type="submit"],
  form.newsletter-thankyou
    .URBAN
    button#submit
    input.cta-button--disabled[type="submit"] {
    background: var(--colour-black);
    color: #ccc !important;
  }

  .standard__cta-button:disabled,
  form.return-form input:disabled[type="submit"],
  form.return-form button#submit:disabled,
  form.customer-form input:disabled[type="submit"],
  form.customer-form button#submit:disabled,
  form.profile-form input:disabled[type="submit"],
  form.profile-form button#submit:disabled,
  .pro-apply .customer-form input:disabled[type="submit"],
  .pro-apply .customer-form button#submit:disabled,
  form.newsletter-thankyou input:disabled[type="submit"],
  form.newsletter-thankyou button#submit:disabled,
  #submit.standard__cta-button input.standard__cta-button:disabled,
  form.return-form
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  form.return-form button#submit input.standard__cta-button:disabled,
  form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  form.customer-form button#submit input.standard__cta-button:disabled,
  form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  form.profile-form button#submit input.standard__cta-button:disabled,
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  .pro-apply .customer-form button#submit input.standard__cta-button:disabled,
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button:disabled,
  form.newsletter-thankyou button#submit input.standard__cta-button:disabled,
  #submit.standard__cta-button form.return-form input:disabled[type="submit"],
  form.return-form #submit.standard__cta-button input:disabled[type="submit"],
  form.return-form input#submit[type="submit"] input:disabled[type="submit"],
  form.return-form button#submit input:disabled[type="submit"],
  #submit.standard__cta-button form.customer-form input:disabled[type="submit"],
  form.customer-form #submit.standard__cta-button input:disabled[type="submit"],
  form.customer-form input#submit[type="submit"] input:disabled[type="submit"],
  form.customer-form button#submit input:disabled[type="submit"],
  #submit.standard__cta-button form.profile-form input:disabled[type="submit"],
  form.profile-form #submit.standard__cta-button input:disabled[type="submit"],
  form.profile-form input#submit[type="submit"] input:disabled[type="submit"],
  form.profile-form button#submit input:disabled[type="submit"],
  #submit.standard__cta-button
    .pro-apply
    .customer-form
    input:disabled[type="submit"],
  .pro-apply
    .customer-form
    #submit.standard__cta-button
    input:disabled[type="submit"],
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input:disabled[type="submit"],
  .pro-apply .customer-form button#submit input:disabled[type="submit"],
  #submit.standard__cta-button
    form.newsletter-thankyou
    input:disabled[type="submit"],
  form.newsletter-thankyou
    #submit.standard__cta-button
    input:disabled[type="submit"],
  form.newsletter-thankyou
    input#submit[type="submit"]
    input:disabled[type="submit"],
  form.newsletter-thankyou button#submit input:disabled[type="submit"] {
    opacity: 0.3;
    color: #ccc;
    cursor: default;
    cursor: not-allowed;
  }

  .standard__cta-button.cta-button--secondary,
  form.return-form input.cta-button--secondary[type="submit"],
  form.return-form button.cta-button--secondary#submit,
  form.customer-form input.cta-button--secondary[type="submit"],
  form.customer-form button.cta-button--secondary#submit,
  form.profile-form input.cta-button--secondary[type="submit"],
  form.profile-form button.cta-button--secondary#submit,
  .pro-apply .customer-form input.cta-button--secondary[type="submit"],
  .pro-apply .customer-form button.cta-button--secondary#submit,
  form.newsletter-thankyou input.cta-button--secondary[type="submit"],
  form.newsletter-thankyou button.cta-button--secondary#submit,
  #submit.standard__cta-button input.standard__cta-button.cta-button--secondary,
  form.return-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--secondary,
  form.return-form
    button#submit
    input.standard__cta-button.cta-button--secondary,
  form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--secondary,
  form.customer-form
    button#submit
    input.standard__cta-button.cta-button--secondary,
  form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--secondary,
  form.profile-form
    button#submit
    input.standard__cta-button.cta-button--secondary,
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--secondary,
  .pro-apply
    .customer-form
    button#submit
    input.standard__cta-button.cta-button--secondary,
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--secondary,
  form.newsletter-thankyou
    button#submit
    input.standard__cta-button.cta-button--secondary,
  #submit.standard__cta-button
    form.return-form
    input.cta-button--secondary[type="submit"],
  form.return-form
    #submit.standard__cta-button
    input.cta-button--secondary[type="submit"],
  form.return-form
    input#submit[type="submit"]
    input.cta-button--secondary[type="submit"],
  form.return-form button#submit input.cta-button--secondary[type="submit"],
  #submit.standard__cta-button
    form.customer-form
    input.cta-button--secondary[type="submit"],
  form.customer-form
    #submit.standard__cta-button
    input.cta-button--secondary[type="submit"],
  form.customer-form
    input#submit[type="submit"]
    input.cta-button--secondary[type="submit"],
  form.customer-form button#submit input.cta-button--secondary[type="submit"],
  #submit.standard__cta-button
    form.profile-form
    input.cta-button--secondary[type="submit"],
  form.profile-form
    #submit.standard__cta-button
    input.cta-button--secondary[type="submit"],
  form.profile-form
    input#submit[type="submit"]
    input.cta-button--secondary[type="submit"],
  form.profile-form button#submit input.cta-button--secondary[type="submit"],
  #submit.standard__cta-button
    .pro-apply
    .customer-form
    input.cta-button--secondary[type="submit"],
  .pro-apply
    .customer-form
    #submit.standard__cta-button
    input.cta-button--secondary[type="submit"],
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.cta-button--secondary[type="submit"],
  .pro-apply
    .customer-form
    button#submit
    input.cta-button--secondary[type="submit"],
  #submit.standard__cta-button
    form.newsletter-thankyou
    input.cta-button--secondary[type="submit"],
  form.newsletter-thankyou
    #submit.standard__cta-button
    input.cta-button--secondary[type="submit"],
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.cta-button--secondary[type="submit"],
  form.newsletter-thankyou
    button#submit
    input.cta-button--secondary[type="submit"] {
    background: #fff;
    color: var(--colour-black);
  }

  .standard__cta-button.cta-button--image,
  form.return-form input.cta-button--image[type="submit"],
  form.return-form button.cta-button--image#submit,
  form.customer-form input.cta-button--image[type="submit"],
  form.customer-form button.cta-button--image#submit,
  form.profile-form input.cta-button--image[type="submit"],
  form.profile-form button.cta-button--image#submit,
  .pro-apply .customer-form input.cta-button--image[type="submit"],
  .pro-apply .customer-form button.cta-button--image#submit,
  form.newsletter-thankyou input.cta-button--image[type="submit"],
  form.newsletter-thankyou button.cta-button--image#submit,
  #submit.standard__cta-button input.standard__cta-button.cta-button--image,
  form.return-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--image,
  form.return-form button#submit input.standard__cta-button.cta-button--image,
  form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--image,
  form.customer-form button#submit input.standard__cta-button.cta-button--image,
  form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--image,
  form.profile-form button#submit input.standard__cta-button.cta-button--image,
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--image,
  .pro-apply
    .customer-form
    button#submit
    input.standard__cta-button.cta-button--image,
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--image,
  form.newsletter-thankyou
    button#submit
    input.standard__cta-button.cta-button--image,
  #submit.standard__cta-button
    form.return-form
    input.cta-button--image[type="submit"],
  form.return-form
    #submit.standard__cta-button
    input.cta-button--image[type="submit"],
  form.return-form
    input#submit[type="submit"]
    input.cta-button--image[type="submit"],
  form.return-form button#submit input.cta-button--image[type="submit"],
  #submit.standard__cta-button
    form.customer-form
    input.cta-button--image[type="submit"],
  form.customer-form
    #submit.standard__cta-button
    input.cta-button--image[type="submit"],
  form.customer-form
    input#submit[type="submit"]
    input.cta-button--image[type="submit"],
  form.customer-form button#submit input.cta-button--image[type="submit"],
  #submit.standard__cta-button
    form.profile-form
    input.cta-button--image[type="submit"],
  form.profile-form
    #submit.standard__cta-button
    input.cta-button--image[type="submit"],
  form.profile-form
    input#submit[type="submit"]
    input.cta-button--image[type="submit"],
  form.profile-form button#submit input.cta-button--image[type="submit"],
  #submit.standard__cta-button
    .pro-apply
    .customer-form
    input.cta-button--image[type="submit"],
  .pro-apply
    .customer-form
    #submit.standard__cta-button
    input.cta-button--image[type="submit"],
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.cta-button--image[type="submit"],
  .pro-apply
    .customer-form
    button#submit
    input.cta-button--image[type="submit"],
  #submit.standard__cta-button
    form.newsletter-thankyou
    input.cta-button--image[type="submit"],
  form.newsletter-thankyou
    #submit.standard__cta-button
    input.cta-button--image[type="submit"],
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.cta-button--image[type="submit"],
  form.newsletter-thankyou
    button#submit
    input.cta-button--image[type="submit"] {
    color: white;
    background: rgba(0, 0, 0, 0.75);
    border: 1px solid white;
    -webkit-transition: background-color 0.5s ease;
    transition: background-color 0.5s ease;
  }

  .standard__cta-button.cta-button--image:hover,
  form.return-form input.cta-button--image:hover[type="submit"],
  form.return-form button.cta-button--image#submit:hover,
  form.customer-form input.cta-button--image:hover[type="submit"],
  form.customer-form button.cta-button--image#submit:hover,
  form.profile-form input.cta-button--image:hover[type="submit"],
  form.profile-form button.cta-button--image#submit:hover,
  .pro-apply .customer-form input.cta-button--image:hover[type="submit"],
  .pro-apply .customer-form button.cta-button--image#submit:hover,
  form.newsletter-thankyou input.cta-button--image:hover[type="submit"],
  form.newsletter-thankyou button.cta-button--image#submit:hover,
  #submit.standard__cta-button
    input.standard__cta-button.cta-button--image:hover,
  form.return-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--image:hover,
  form.return-form
    button#submit
    input.standard__cta-button.cta-button--image:hover,
  form.customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--image:hover,
  form.customer-form
    button#submit
    input.standard__cta-button.cta-button--image:hover,
  form.profile-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--image:hover,
  form.profile-form
    button#submit
    input.standard__cta-button.cta-button--image:hover,
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--image:hover,
  .pro-apply
    .customer-form
    button#submit
    input.standard__cta-button.cta-button--image:hover,
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.standard__cta-button.cta-button--image:hover,
  form.newsletter-thankyou
    button#submit
    input.standard__cta-button.cta-button--image:hover,
  #submit.standard__cta-button
    form.return-form
    input.cta-button--image:hover[type="submit"],
  form.return-form
    #submit.standard__cta-button
    input.cta-button--image:hover[type="submit"],
  form.return-form
    input#submit[type="submit"]
    input.cta-button--image:hover[type="submit"],
  form.return-form button#submit input.cta-button--image:hover[type="submit"],
  #submit.standard__cta-button
    form.customer-form
    input.cta-button--image:hover[type="submit"],
  form.customer-form
    #submit.standard__cta-button
    input.cta-button--image:hover[type="submit"],
  form.customer-form
    input#submit[type="submit"]
    input.cta-button--image:hover[type="submit"],
  form.customer-form button#submit input.cta-button--image:hover[type="submit"],
  #submit.standard__cta-button
    form.profile-form
    input.cta-button--image:hover[type="submit"],
  form.profile-form
    #submit.standard__cta-button
    input.cta-button--image:hover[type="submit"],
  form.profile-form
    input#submit[type="submit"]
    input.cta-button--image:hover[type="submit"],
  form.profile-form button#submit input.cta-button--image:hover[type="submit"],
  #submit.standard__cta-button
    .pro-apply
    .customer-form
    input.cta-button--image:hover[type="submit"],
  .pro-apply
    .customer-form
    #submit.standard__cta-button
    input.cta-button--image:hover[type="submit"],
  .pro-apply
    .customer-form
    input#submit[type="submit"]
    input.cta-button--image:hover[type="submit"],
  .pro-apply
    .customer-form
    button#submit
    input.cta-button--image:hover[type="submit"],
  #submit.standard__cta-button
    form.newsletter-thankyou
    input.cta-button--image:hover[type="submit"],
  form.newsletter-thankyou
    #submit.standard__cta-button
    input.cta-button--image:hover[type="submit"],
  form.newsletter-thankyou
    input#submit[type="submit"]
    input.cta-button--image:hover[type="submit"],
  form.newsletter-thankyou
    button#submit
    input.cta-button--image:hover[type="submit"] {
    background: black;
    text-decoration: none !important;
  }

  .standard__cta-button.formSubmitSpinner,
  form.return-form input.formSubmitSpinner[type="submit"],
  form.return-form button.formSubmitSpinner#submit,
  form.customer-form input.formSubmitSpinner[type="submit"],
  form.customer-form button.formSubmitSpinner#submit,
  form.profile-form input.formSubmitSpinner[type="submit"],
  form.profile-form button.formSubmitSpinner#submit,
  .pro-apply .customer-form input.formSubmitSpinner[type="submit"],
  .pro-apply .customer-form button.formSubmitSpinner#submit,
  form.newsletter-thankyou input.formSubmitSpinner[type="submit"],
  form.newsletter-thankyou button.formSubmitSpinner#submit {
    pointer-events: none;
  }

  .formSubmitSpinner:after {
    content: " ";
    -webkit-animation: rotate 0.8s infinite linear;
    animation: rotate 0.8s infinite linear;
    border: 3px solid #fff;
    border-right-color: transparent;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    position: absolute;
    left: 47.5%;
    top: 10px;
    -webkit-transform: translate(50%);
    transform: translate(50%);
    z-index: 99;
  }

  @-webkit-keyframes rotate {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes rotate {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .disabled,
  .disabled:hover,
  .disabled input,
  .disabled:hover input,
  input[disabled="disabled"],
  input[disabled="disabled"]:hover {
    cursor: default !important;
  }

  #btnGuest input {
    color: green;
  }

  .sprite-search-no-products-collections {
    background-image: url(../../graphics/spritesheet-search.png);
    background-position: 0px 0px;
    width: 300px;
    height: 302px;
  }

  .sprite-search-no-products-contact {
    background-image: url(../../graphics/spritesheet-search.png);
    background-position: -300px 0px;
    width: 145px;
    height: 148px;
  }

  .sprite-search-no-products-faq {
    background-image: url(../../graphics/spritesheet-search.png);
    background-position: 0px -302px;
    width: 145px;
    height: 148px;
  }

  .sprite-search-no-products-mens {
    background-image: url(../../graphics/spritesheet-search.png);
    background-position: -145px -302px;
    width: 300px;
    height: 147px;
  }

  .sprite-search-no-products-stores {
    background-image: url(../../graphics/spritesheet-search.png);
    background-position: -300px -148px;
    width: 300px;
    height: 148px;
  }

  .sprite-search-no-products-womens {
    background-image: url(../../graphics/spritesheet-search.png);
    background-position: -445px 0px;
    width: 300px;
    height: 145px;
  }

  #frameService {
    margin-bottom: 30px;
  }

  .CORPSALE {
    background: #eee;
    padding-top: 30px;
  }

  .CORPSALE #btnSubmit {
    border: 1px solid #cfcfcf;
  }

  #divEndUserSignUp,
  #divEndUserInfo {
    background: #fff;
    padding: 30px 10px 30px 55px;
  }

  #divEndUserSignUp h1,
  #divEndUserSignUp h2,
  #divEndUserSignUp h3,
  #divEndUserInfo h1,
  #divEndUserInfo h2,
  #divEndUserInfo h3 {
    font-family: var(--font-helvetica);
  }

  #divEndUserSignUp ul,
  #divEndUserInfo ul {
    list-style: disc;
  }

  #divEndUserSignUp ol,
  #divEndUserInfo ol {
    list-style: lower-roman;
  }

  .registerSimple,
  #emailWishlist {
    background: #fff;
  }

  #divNoWebServices {
    font-size: 14px;
    margin: 30px;
  }

  #divEndUserForm,
  #divEndUserOrderStatus,
  #divAlert,
  #divPasswordReminder {
    width: 610px;
    margin: 0 auto;
    padding: 0 0 45px 0;
  }

  @media screen and (max-width: 767px) {
    #divEndUserForm,
    #divEndUserOrderStatus,
    #divAlert,
    #divPasswordReminder {
      width: 100%;
    }
  }

  .ADDRESS #divEndUserForm,
  .ADDRESSBOOK #divEndUserForm {
    width: 640px;
  }

  @media screen and (max-width: 767px) {
    .ADDRESS #divEndUserForm,
    .ADDRESSBOOK #divEndUserForm {
      width: 100%;
    }
  }

  form.simplify #divEndUserForm,
  form #divPasswordReminder {
    background: #fff;
    width: 450px;
    height: 256px;
    padding: 20px 0 0 20px;
  }

  #bodyPasswordReminder {
    padding: 11px 0;
  }

  #bodyPasswordReminder #divArticleFull {
    padding: 0;
  }

  .bvSubmit #userLoginGroup {
    padding: 28px 0 0 115px;
  }

  #divEndUserForm h2 {
    font-weight: normal;
    text-align: left;
    margin: 0;
    padding: 0 0 26px 0;
  }

  .profile-edit #divEndUserForm h2,
  .change-email #divEndUserForm h2 {
    padding: 0 0 15px 0;
  }

  .register #divEndUserForm h2 {
    padding: 0 0 24px 0;
  }

  #bodyReturnExchange #divEndUserForm h2 {
    padding: 0 0 23px 0;
  }

  #divEndUserAlert h2,
  #divEndUserAlertSummary h2 {
    font-weight: normal;
  }

  #divPasswordReminder #lblWelcome h2 {
    font-size: 17px;
    font-weight: normal;
    text-align: left;
  }

  #divEndUserForm h2#h2WishList {
    float: left;
    display: inline;
    clear: left;
    width: 600px;
    padding-top: 21px;
  }

  #ErrorMsg,
  #ShipMsg,
  #divPwdError {
    background: #fbb;
    border: 1px solid #900;
    color: #fff;
    font-weight: bold;
    border-radius: 2px;
    margin: 0 0 15px 0;
    padding: 10px;
    width: 96%;
    background-image: linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
    background-size: 30px 30px;
  }

  @media screen and (max-width: 767px) {
    #ErrorMsg,
    #ShipMsg,
    #divPwdError {
      width: auto;
    }
  }

  @media screen and (max-width: 767px) {
    #ShipMsg {
      width: 93%;
      padding: 3%;
    }
  }

  #divPwdError a {
    color: #770000;
  }

  #ErrorMsg span#lblErrorMsg {
    font-family: Arial, Helvetica, sans-serif;
    display: block;
    color: #300;
    margin: 0;
    padding: 0;
  }

  #ErrorMsg span#lblErrorMsg a {
    color: #444;
    text-decoration: underline;
  }

  #ErrorMsg.goodMsg,
  #ShipMsg.goodMsg {
    background: #adffad;
    border: 1px solid #393;
  }

  #ErrorMsg.goodMsg span#lblErrorMsg,
  #ShipMsg.goodMsg span#lblShipMsg {
    color: #262;
  }

  .loginMessage {
    padding: 0 0 10px;
  }

  #divForgotPassword {
    clear: both;
    padding: 0 0 15px;
  }

  label.placeholder {
    position: absolute;
    left: 7px;
    top: 5px;
    cursor: text;
  }

  span.limitedWarranty {
    text-decoration: underline;
    cursor: pointer;
  }

  .formField {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 0 13px 0;
    clear: both;
    overflow: auto;
  }

  .formField[valid="valid"]#shippingOptionsField {
    padding-right: 0;
  }

  #divPasswordReminder {
    padding-top: 20px;
  }

  #divPasswordReminder #emailField {
    width: 316px;
  }

  #divPasswordReminder .formField {
    overflow: visible;
  }

  #divPasswordReminder .formInput {
    border: none;
  }

  #divPasswordReminder #email {
    border: 1px solid #888;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: #fff;
    width: 100%;
    height: 26px;
    border-radius: 3px;
    padding: 0 10px;
  }

  #divPasswordReminder #ErrorMsg {
    width: 90%;
  }

  label {
    line-height: 16px;
  }

  .CONTACT .form-row.state label::after {
    content: "*";
    color: #a30200;
  }

  #divOptInArcLbl,
  #divOptInUrbanLbl {
    padding-right: 10px;
  }

  select {
    border: 1px solid #fff;
    background: #fff;
    font-size: 13px;
  }

  #divShippingOptions select {
    font-size: 11px;
  }

  .formField[valid="valid"] {
    padding-right: 26px;
  }

  .formField[valid="valid"] .formHintContainer {
    float: left;
  }

  .formField[valid="info"] .formHintContainer,
  .formField[valid="error"] .formHintContainer {
    float: none;
    clear: both;
    overflow: auto;
  }

  .formHint {
    margin: 7px 0 0 0;
    z-index: 99;
  }

  @media screen and (min-width: 768px) {
    .formHint {
      position: absolute;
      width: 100%;
      margin: -3px 0 0 0;
    }
  }

  .formHintError {
    background: url(/graphics/forms/hintArrowRed.png) no-repeat left top;
    z-index: 1000;
  }

  @media screen and (min-width: 768px) {
    .formHintError {
      position: static;
      margin: 7px 0 0 0;
    }
  }

  .formHintContents {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: #e5e5e5;
    border: 1px solid #999;
    margin: 0;
    padding: 2px 5px 2px;
    width: 100%;
    max-width: 290px;
  }

  @media screen and (min-width: 768px) {
    .formHintContents {
      border-radius: 0 0 4px 4px;
    }
  }

  .formHintValid {
    background: none;
    z-index: 99;
    position: absolute;
    margin: 0 0 0 -4px !important;
  }

  #txtOrderNotesHint {
    margin: 0 0 0 -1px !important;
  }

  .formHintContentsValid {
    background: #cbf5cb;
    border: 1px solid #2d9f45;
    width: 28px;
    padding: 5px 5px 7px !important;
    border-radius: 0 4px 4px 0 !important;
  }

  .formHintContentsValid img {
    display: block;
    margin: 0 auto;
  }

  .formHintContentsValidMessage {
    max-width: 218px;
    width: auto;
  }

  .formHintContentsError {
    color: #600;
    border-color: #933;
    background-color: #ffadad;
    border-radius: 0;
  }

  .formHintContentsError:before {
    content: "\\00d7\\00a0";
  }

  .formInput {
    width: 100%;
    max-width: 290px;
    border: 1px solid #888;
    border-radius: 4px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .formField[valid="valid"] .formInput {
    float: left;
  }

  #shippingOptionsField select .formInput {
    font-size: 11px;
  }

  #divUserEmail #divEMailAddress {
    border: none;
  }

  .checkbox {
    width: 15px;
    height: 15px;
    padding: 0;
    margin: 0 5px 0 0;
  }

  textarea.formInput_input {
    border: #fff solid 1px;
    height: 92px !important;
    max-width: 100%;
  }

  input.formInput_input {
    padding: 0 10px;
  }

  .formInput_head div {
    margin: 0;
    border: 0;
    height: auto !important;
    height: 1%;
  }

  .formInput_input {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: #fff;
    width: 100%;
    height: 26px;
    border-radius: 3px;
  }

  #divPrivacy,
  #privacy {
    padding: 0 0 13px;
  }

  @media screen and (max-width: 767px) {
    #divPrivacy,
    #privacy {
      padding: 0 0 13px 0;
    }
  }

  #divPrivacyPolicy {
    background-color: #ffffff;
    padding: 3em;
  }

  @media screen and (max-width: 479px) {
    #divPrivacyPolicy {
      padding: 1em;
    }
  }

  #divForgotPwd {
    padding: 0 0 13px;
  }

  select#showCommon {
    font-weight: normal;
    width: 170px !important;
  }

  @media screen and (max-width: 929px) {
    select#showCommon {
      width: 90px !important;
    }
  }

  * + html body.GERMAN select#showCommon option,
  * + html body.FRENCH select#showCommon option {
    width: 160px !important;
  }

  * + html body.GERMAN select#showCommon,
  * + html body.FRENCH select#showCommon {
    font-size: 10px;
  }

  body.GERMAN select#showCommon {
    font-size: 11px;
    line-height: 9px;
  }

  * + html body.GERMAN select#showCommon {
    width: 160px;
  }

  .column {
    background: #fff;
    border-radius: 2px;
    float: left;
    display: inline;
    width: 260px;
    min-height: 260px;
    margin: 0 0 30px 0;
    padding: 15px;
  }

  @media screen and (max-width: 767px) {
    .column {
      width: 92.5%;
      padding: 11px;
    }
  }

  #newUser {
    background: #f2f2f2;
    display: block;
    margin-bottom: 45px;
  }

  ul.left,
  div.left {
    margin-right: 30px;
    padding: 0;
    width: 290px;
    min-height: 290px;
  }

  @media screen and (max-width: 767px) {
    ul.left,
    div.left {
      margin-right: 0;
      padding: 0;
      width: 100%;
    }
  }

  .column li {
    padding: 0 0 0 0;
    width: 278px;
    overflow: auto;
  }

  .column li.columnTitle {
    border-bottom: 1px solid #ddd;
    padding: 0 0 5px;
  }

  .column li.columnTitle h3 {
    float: left;
    display: inline;
  }

  .column li.columnTitle a {
    float: right;
    display: inline;
  }

  #divEndUserForm .column p {
    padding: 0 0 13px;
  }

  .column #divForgotPwd {
    padding: 0 0 13px;
  }

  #emailWishlist #divEndUserForm,
  .registerSimple #form1 {
    display: block;
    width: auto;
    margin: 0;
    padding: 40px;
  }

  #emailWishlist .formHint {
    display: none;
  }

  #divEndUserAlert #articleTitle {
    padding: 0 0 18px 0;
  }

  #divEndUserAlert #articleBody {
    background: #f2f2f2;
    border-radius: 2px;
    margin: 0 0 23px;
    padding: 15px;
  }

  #divLocationAlert2 {
    clear: both;
  }

  #divCartContents {
    width: 465px;
    padding: 40px 0 40px;
    overflow: auto;
  }

  #divCartContents .formLabel {
    float: left;
    display: inline;
    margin: 0 0 0;
  }

  .LOCATIONCHANGE #divCartContents .formLabel {
    width: 100px;
    margin-right: 20px;
    float: left;
    text-align: right;
  }

  #divInStockItems,
  #divOutOfStockItems {
    float: left;
    display: inline;
  }

  .LOCATIONCHANGE #divOutOfStockItems {
    margin-left: 120px;
  }

  #divInStockItems span,
  #divOutOfStockItems span {
    float: left;
    display: inline-block;
    clear: left;
    padding: 8px 0;
  }

  #divInStockItems span span,
  #divOutOfStockItems span span {
    padding: 0;
  }

  @media screen and (max-width: 767px) {
    #divCartContents {
      width: 100%;
      padding: 40px 0 40px 0px;
    }

    #divCartContents .formLabel {
      margin: 0 0 0 0;
    }
  }

  #divEndUserForm #divSSNDetails1 p,
  #divEndUserForm #divSSNDetails2 p {
    padding-left: 0;
  }

  #divEndUserAlertSummary {
    background: #f2f2f2;
    border-radius: 2px;
    line-height: 15px;
    display: block;
    clear: both;
    margin: 0 0 15px 0;
    padding: 15px;
  }

  #divEndUserAlertSummary p {
    padding-left: 0;
  }

  #divEndUserAlertSummary ul {
    list-style: disc outside none;
    padding-left: 15px;
  }

  #divEndUserAlertSummary ul li {
    padding: 0 0 4px 0;
  }

  #divShippingOptions select {
    width: inherit;
    height: 26px;
  }

  #divShipAddress {
    padding: 43px 0 0;
    overflow: auto;
  }

  #divShipAddress label {
    width: 100px;
    float: left;
    text-align: right;
  }

  #divShipAddress address {
    float: left;
    display: inline;
    text-align: left;
    padding: 0 15px 8px 0;
    width: 100px;
    margin-left: 12px;
  }

  @media screen and (max-width: 767px) {
    #divShipAddress address {
      width: 100px;
      text-align: right;
      float: left;
    }
  }

  #divShipAddress address {
    float: left;
    display: inline;
    padding: 0 0 0 10px;
  }

  @media screen and (max-width: 767px) {
    #divShipAddress address {
      width: 50%;
      text-align: left;
      float: left;
    }
  }

  .ORDERSTATUS #divOptions {
    margin: 0 0 30px -15px;
  }

  .ORDERSTATUS #divOptions input {
    margin: 0 3px 0 15px;
  }

  #divOrderStatus .order {
    background-color: #ffffff;
    border-radius: 2px;
    margin-bottom: 30px;
  }

  .order dl {
    float: left;
    display: inline;
    width: 75px;
    padding: 0 10px 10px 0;
  }

  .order dl.orderNumber,
  .order dl.packSlipNumber {
    width: 90px;
  }

  .GERMAN .order dl.orderNumber {
    width: 100px;
  }

  .order dl.orderStatus {
    width: 400px;
    padding-right: 0;
  }

  #divEndUserForm dl.orderStatus p {
    padding: 0 0 5px 0;
  }

  .order dt {
    font-weight: bold;
    padding: 0 0 10px 0;
  }

  .order dl.orderNumber dd,
  .order dl.packSlipNumber dd {
    font-size: 13px;
    font-weight: bold;
  }

  .order dl.orderNumber dd,
  .order dl.packSlipNumber dd {
    color: #0d2b5b;
  }

  .order dd p {
    margin: 0;
    padding: 0 0 5px;
  }

  .order .items {
    background: #f4f4f4;
    color: #333;
    clear: left;
    overflow: auto;
    padding: 10px 0 10px 10px;
  }

  .order .items dl {
    padding: 0;
    text-align: center;
  }

  .order .items dl.itemDescription {
    width: 230px;
    text-align: left;
  }

  .order .items dl.itemQuantity {
    width: 40px;
  }

  .order .items dl.itemCost {
    width: 80px;
  }

  .order .items dl.itemTotal {
    width: 80px;
  }

  .order .items dd {
    padding: 0 0 2px;
  }

  .itemCost dt,
  .itemCost dd {
    text-align: right;
  }

  .itemTotal dt,
  .itemTotal dd {
    text-align: right;
  }

  .order ul.orderTotal {
    clear: left;
    width: 300px;
    padding: 10px 0 0 280px;
    text-align: right;
  }

  .ORDERSTATUS.URBAN .order ul.orderTotal {
    width: 580px;
    padding: 10px 0 0 0;
  }

  @media screen and (max-width: 639px) {
    .ORDERSTATUS.URBAN .order ul.orderTotal {
      width: 90%;
      padding: 10px 0 0 0;
    }
  }

  .order ul.orderTotal li {
    display: block;
    clear: both;
  }

  .order ul.orderTotal li span {
    float: right;
    display: inline-block;
    font-weight: bold;
    width: 80px;
    padding: 0 0 2px 0;
  }

  #divTitleBlurb {
    padding: 0 0 20px;
  }

  #divTitleBlurb h2 {
    padding: 0 0 5px;
  }

  #CustomerType .formInput,
  #CustomerType .formInput_bottom,
  #CustomerType .formInput_head,
  #CustomerType .formInput_head div {
    background: none;
    padding: 0px;
  }

  #CustomerType .formInput {
    padding: 5px 0 0;
  }

  #CustomerType label,
  #CustomerType input {
    float: left;
    display: inline;
  }

  #CustomerType input {
    margin: 3px 5px 0 0;
  }

  #CustomerType label {
    display: inline-block;
    padding: 2px 18px 0 0;
  }

  #benefits {
    background: #e4e4e4;
    width: 650px;
    margin: 30px 60px;
    padding: 15px;
    overflow: auto;
  }

  #benefits img {
    float: right;
    display: inline;
    margin-left: 10px;
  }

  #benefits ol {
    padding: 10px 0;
  }

  #benefits ol li {
    list-style: inside decimal none;
    padding: 0 0 3px 20px;
  }

  .disclaimer {
    color: #999;
  }

  #OptIns,
  #OptIns .formInput,
  #OptIns .formInput_bottom,
  #OptIns .formInput_head,
  #OptIns .formInput_head div,
  #pnlPro1,
  #pnlPro1 .formInput,
  #pnlPro1 .formInput_bottom,
  #pnlPro1 .formInput_head,
  #pnlPro1 .formInput_head div {
    margin: 0;
    padding: 0;
    border: none;
  }

  #pnlPro1 .formInput {
    margin: 0 0 0 10px;
    padding: 9px 0 0;
  }

  #pnlPro1 .formInput input {
    float: left;
    display: inline;
    margin: 0 5px 0 0;
  }

  #pnlPro1 .formInput label {
    float: left;
    display: inline;
    line-height: 100%;
  }

  .optmarket,
  #pnlOpt {
    line-height: 0px;
    display: block;
    padding: 0 0 13px;
    overflow: auto;
  }

  @media screen and (max-width: 767px) {
    .optmarket,
    #pnlOpt {
      padding: 0 0 0 0;
    }
  }

  .optmarket input,
  #pnlOpt input {
    float: left;
    display: inline;
    width: 15px;
    height: 15px;
    margin: 0px 3px 0 0;
    padding: 0;
  }

  #pnlPro2 td,
  #tdSpecialty td {
    display: block;
    padding: 0 0 2px 10px;
  }

  #pnlSubmitRequired {
    padding: 0;
  }

  #emailEditBlock #lblEmailRslt,
  #lblShippingHeader,
  #divWarrNotes {
    display: block;
    padding: 0 0 13px;
  }

  @media screen and (max-width: 479px) {
    #emailEditBlock #lblEmailRslt,
    #lblShippingHeader,
    #divWarrNotes {
      padding-left: 0;
    }
  }

  #pnlResidential {
    padding: 0 0 13px 150px;
  }

  #pnlPro2,
  #lblInfo,
  #lblAttach {
    display: block;
    padding: 0;
  }

  @media screen and (max-width: 479px) {
    #pnlPro2,
    #lblInfo,
    #lblAttach {
      padding-left: 0;
    }
  }

  #lblInfo b {
    display: block;
  }

  #lblInfo ul {
    font-weight: bold;
  }

  #lblInfo ul li {
    font-weight: normal;
  }

  #pnlPro2 #rbtnType {
    width: 300px !important;
  }

  #pnlPro2 .formInput {
    margin: 15px 0 0 0;
  }

  #divDescr {
    display: inline-block;
    padding: 9px 0 0;
  }

  @media screen and (max-width: 479px) {
    #divDescr {
      text-align: left;
      width: 100%;
    }
  }

  #txtNotesField #txtNotesHint {
    margin-top: 15px;
  }

  #FileUploadField .fileupload {
    margin: 15px 0 0;
  }

  @media screen and (max-width: 479px) {
    #FileUploadField .fileupload {
      border: 0;
      margin-left: 0;
      padding: 0;
      width: 100%;
    }
  }

  #FileUploadField .formInput,
  #FileUploadField .formInput_bottom,
  #FileUploadField .formInput_head,
  #FileUploadField .formInput_head div {
    background: none;
  }

  form input#fileupload {
    height: auto !important;
  }

  #fileuploadHintContainer {
    display: none !important;
  }

  #panelMailSent {
    width: 100% !important;
    max-width: 500px;
  }

  .error {
    font-weight: bold;
    color: #990000;
  }

  #tdSpecialty,
  #tdSpecialtytbl {
    display: none;
  }

  #tdProSegment {
    display: block;
  }

  #pnlPro2 td,
  #tdSpecialty td {
    vertical-align: top;
  }

  #divGroupMsg {
    display: none;
  }

  #footerLoginPane label {
    float: left;
    display: inline-block;
    color: #fff;
    padding: 2px 10px 0 0;
  }

  #footerLoginPane span label {
    position: absolute;
    left: 5px;
  }

  #footerLoginPane span.input,
  #footerLoginPane span.input input {
    background: transparent url(/graphics/forms/form-elements.png) no-repeat
      left -226px;
    border: none;
    color: #fff;
    margin: 0;
    position: relative;
  }

  #footerLoginPane span.input {
    background-position: left -226px;
    float: left;
    display: inline-block;
    height: 21px;
    margin: 0 3px 0 0;
  }

  #footerLoginPane span.input input {
    background: transparent url(/graphics/forms/form-elements.png) no-repeat
      right -226px !important;
    float: left;
    display: inline;
    width: 165px !important;
    height: 19px;
    padding: 2px 5px 0 5px;
  }

  #footerLoginPane span.button,
  #footerLoginPane span.button input {
    background: transparent url(/graphics/forms/form-elements.png) no-repeat
      left -247px;
    border: none;
    color: #ccc;
    margin: 0;
  }

  #footerLoginPane span.button {
    background-position: left -247px;
    float: left;
    display: inline-block;
    clear: none;
    height: 21px;
  }

  #footerLoginPane span.button input {
    background-position: right -247px;
    float: none;
    height: 21px;
    padding: 0 10px;
    *padding: 0 2px;
  }

  #footerLoginPane span.button input:hover {
    color: #fff;
  }

  #LocationChange span.highlight {
    float: right;
  }

  span.button:active {
    -ms-background-position-y: 1px;
    *-ms-background-position-y: 1px;
  }

  input#btnSubmit:active {
    -ms-background-position-y: 1px;
  }

  #divNoWebServices[hidden="true"] {
    display: none;
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  #contactStrategy .newsletter-signup {
    padding: 36px 0 120px 0;
    max-width: 880px;
  }

  #contactStrategy .newsletter-signup h3 {
    padding: 0 20px;
    color: #82b2d8;
    font-size: 18px;
    text-transform: uppercase;
  }

  #contactStrategy .newsletter-signup p {
    padding: 0 20px;
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    text-transform: none;
  }

  #contactStrategy .newsletter-signup form {
    height: 36px;
    width: 500px;
    margin: 0 auto;
    display: block;
    float: none;
    position: relative;
  }

  #contactStrategy .newsletter-signup form #news-tooltip {
    height: 44px;
    width: 302px;
    padding: 8px 4px 8px 6px;
    position: absolute;
    bottom: -82px;
    left: 0;
    background: #ccc;
    font-size: 11px;
    color: var(--colour-black);
    line-height: 1.2;
    border-radius: 1px;
    text-align: left;
  }

  #contactStrategy .newsletter-signup form #news-tooltip a {
    color: var(--colour-black);
  }

  #contactStrategy .newsletter-signup form #news-tooltip span {
    position: absolute;
    top: -10px;
    left: 20px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #ccc;
  }

  #contactStrategy .newsletter-signup .placeholder {
    width: 100px;
    top: 10px;
    left: 10px;
    font-style: italic;
    color: #b8b8b8;
  }

  #contactStrategy .newsletter-signup p {
    padding: 0 0 12px 0 !important;
  }

  #contactStrategy .newsletter-signup #homeEMail {
    border-radius: 1px;
    height: 36px;
    width: 296px;
  }

  #contactStrategy .newsletter-signup #btnNewsletterSignup {
    height: 36px;
    width: 142px;
    float: left;
    margin: 0 0 0 8px;
    background: none;
    color: #fff;
    cursor: pointer;
    border: 1px solid #fff;
    text-transform: uppercase;
    font-size: 15px;
    font-weight: bold;
    border-radius: 2px;
  }

  #contactStrategy .newsletter-signup.white-bg {
    background: #fff;
    border: 1px solid var(--colour-black);
  }

  #contactStrategy .newsletter-signup.white-bg h3 {
    color: var(--colour-black);
  }

  #contactStrategy .newsletter-signup.white-bg p {
    color: var(--colour-black);
  }

  #contactStrategy .newsletter-signup.white-bg #homeEMail {
    background: #fff;
    border: 1px solid var(--colour-black);
  }

  #contactStrategy .newsletter-signup.white-bg #btnNewsletterSignup {
    background: var(--colour-black);
    color: #fff;
  }

  #newsletter-thankyou {
    max-width: 630px;
    height: 710px;
    margin: 0 auto;
    border: 1px solid var(--colour-black);
    background: url(../img/news-thank-bg.jpg) no-repeat top left;
  }

  #newsletter-thankyou .inner-container {
    max-width: 381px;
    float: right;
    margin: 32px 16px;
  }

  #newsletter-thankyou .inner-container .customer-form {
    padding-left: 0;
    padding-right: 0;
  }

  #newsletter-thankyou .inner-container .customer-form .form-row {
    padding: 10px 0;
  }

  #newsletter-thankyou .inner-container .customer-form .activites h4 {
    padding: 0 0 6px 0;
    font-weight: normal;
  }

  #newsletter-thankyou .inner-container .customer-form .activites input {
    float: left;
    margin: 2px 0 0 0;
  }

  #newsletter-thankyou
    .inner-container
    .customer-form
    .activites
    input:nth-of-type(3) {
    clear: both;
  }

  #newsletter-thankyou .inner-container .customer-form .activites label {
    float: left;
    clear: none;
    padding: 0 20px 10px 4px;
  }

  #newsletter-thankyou .inner-container h2 {
    font-size: 24px;
    color: var(--colour-black);
    text-transform: uppercase;
    margin-bottom: 11px;
  }

  #newsletter-thankyou .inner-container h3 {
    padding: 20px 0 6px 0;
    margin: 6px 0 0 0;
    font-size: 18px;
    color: var(--colour-black);
    text-transform: uppercase;
    border-top: 1px solid #989898;
  }

  #newsletter-thankyou .inner-container p {
    color: #565656;
    text-transform: none;
    font-size: 14px;
    line-height: 1.5;
  }

  #newsletter-thankyou .inner-container p.disclaimer {
    margin: 20px 0 0 0;
    font-size: 12px;
    line-height: 1.3;
  }

  #newsletter-thankyou .inner-container p.disclaimer a {
    border-bottom: 1px solid #565656;
  }

  #newsletter-thankyou .inner-container #btnSubmit {
    height: 40px;
    width: 150px;
    clear: both;
    display: block;
    margin: 56px 0 0 0;
    background: var(--colour-black);
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }

  #newsletter-thankyou.newsletter-success .inner-container {
    width: 381px;
  }

  #newsletter-thankyou.newsletter-success .btnShopNow {
    cursor: pointer;
    float: left;
    margin: 0 12px 0 0;
    height: 40px;
    width: 150px;
    background: var(--colour-black);
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    background: var(--colour-black);
  }

  @media (max-width: 600px) {
    #divHomeContent .newsletter-signup form {
      margin: 0 auto;
      width: 100%;
    }

    #divHomeContent .newsletter-signup form #homeEMail {
      max-width: 200px;
    }

    #newsletter-thankyou {
      background: none;
    }

    #newsletter-thankyou .inner-container {
      float: none;
      margin: 36px auto;
    }
  }

  #serviceForm h1 {
    font-size: 18px;
    line-height: 16px;
    text-align: center;
  }

  .SERVICE-FORMS #content {
    max-width: 960px;
    margin: 0 auto;
    padding: 12px 3% 0 3%;
  }

  @media screen and (min-width: 930px) {
    .SERVICE-FORMS #content {
      padding: 30px 0 0 0 !important;
    }
  }

  .SERVICE-FORMS #content #minorContent {
    display: none;
  }

  @media screen and (min-width: 930px) {
    .SERVICE-FORMS #content #minorContent {
      display: block;
      max-width: 300px;
    }
  }

  .SERVICE-FORMS #content #mainContent {
    display: block;
    max-width: 610px;
  }

  .form-submit-result {
    width: 100%;
    min-height: 500px;
  }

  .form-submit-result h3 {
    text-align: center;
    margin-top: 40px;
  }

  .VOLTAIR-REGISTRATION #mainContent {
    float: none;
    width: 100%;
  }

  .VOLTAIR-REGISTRATION #content form.customer-form .form-row p,
  .VOLTAIR-REGISTRATION form.newsletter-thankyou .form-row p {
    padding: 0;
    margin: 0;
    font-size: 0.9em;
    color: #333;
  }

  .enduser {
    background: white;
  }

  .enduser .enduser-header {
    background: var(--colour-black)
      url(//images.arcteryx.com/enduser-signup/header.jpg) no-repeat center
      bottom;
    background-size: cover;
    width: 100%;
    height: 207px;
  }

  @media screen and (max-width: 479px) {
    .enduser .enduser-header {
      display: none;
    }
  }

  .enduser .logo {
    background: var(--colour-black);
    display: inline-block;
    padding: 56px 25px 25px 60px;
    margin-left: 40px;
  }

  .enduser .enduser-signup {
    max-width: 750px;
    padding: 40px 40px 0;
    position: relative;
  }

  @media screen and (max-width: 479px) {
    .enduser .enduser-signup {
      width: 100%;
      padding: 4%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
  }

  .enduser .intro-block {
    float: left;
    max-width: 295px;
    margin: 0 0 20px;
  }

  .enduser .intro-block h2 {
    font: 38px var(--font-helvetica);
    margin: 0 0 10px;
  }

  .enduser .intro-block h2 span {
    font-size: 41px;
    line-height: 25px;
    display: block;
    color: #a30200;
  }

  .enduser .intro-block h3 {
    font-size: 25px;
    padding: 0 0 20px;
  }

  .enduser .intro-block p {
    font-size: 14px;
    width: 280px;
  }

  .enduser .signup-form {
    float: right;
    padding: 0 0 50px;
  }

  @media screen and (max-width: 479px) {
    .enduser .signup-form {
      position: static;
      width: 100%;
    }
  }

  .enduser .monthly-winner {
    background: #f2f2f2;
    float: left;
    clear: left;
    position: relative;
    width: 165px;
    padding: 40px 0 40px 88px;
    overflow: visible;
    margin: 30px 0 60px 60px;
  }

  .enduser .monthly-winner h4 {
    padding-bottom: 20px;
  }

  .enduser .monthly-winner p {
    padding-bottom: 0;
  }

  .enduser .monthly-winner img {
    position: absolute;
    left: -80px;
    top: -30px;
  }

  .enduser .rules {
    clear: both;
  }

  .enduser .formField[valid="info"] .formHintContainer,
  .enduser .formField[valid="error"] .formHintContainer {
    float: none;
    clear: both;
    overflow: auto;
    width: 211px;
  }

  .enduser .formField[valid="info"] .formHint,
  .enduser .formField[valid="error"] .formHint {
    background: none;
    float: none;
    position: relative;
    margin: 11px 0 0 0;
  }

  .enduser .formHintContents {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-left: 1px solid #999;
    margin: 0;
    width: 100%;
  }

  .enduser .formHintContentsError {
    border-left: 1px solid #933;
  }

  .enduser .formHintValid {
    margin-left: -2px;
  }

  .enduser .formHintContentsValid {
    width: 28px;
  }

  .enduser .optmarket label {
    display: inline-block;
  }

  @media screen and (min-width: 768px) {
    #cardType .formHint {
      width: 182px;
      margin: -28px 0 0 100px;
    }

    #cardType .formHint .formHintContents {
      padding: 3px 5px 4px;
      border-radius: 4px;
    }
  }

  #expiremonth_input,
  #expireyear_input {
    width: inherit;
  }

  #WhatIsCCVNumberField {
    display: none;
  }

  #cardType .formInput,
  #CCVNumberField .formInput {
    width: 30%;
  }

  #cardType .formField[valid="valid"],
  #CCVNumberField .formField[valid="valid"] {
    padding-right: 0;
  }

  #cmbCardType {
    width: 100%;
  }

  #expiremonth_input,
  #expireyear_input,
  #BirthDateField .select {
    float: left;
    width: 30%;
    margin-right: 11px;
  }

  #expiremonth_input #birthmonth_input,
  #expiremonth_input #birthyear_input,
  #expiremonth_input select,
  #expireyear_input #birthmonth_input,
  #expireyear_input #birthyear_input,
  #expireyear_input select,
  #BirthDateField .select #birthmonth_input,
  #BirthDateField .select #birthyear_input,
  #BirthDateField .select select {
    width: 100%;
  }

  #cmbBirthMonth,
  #cmbBirthYear,
  #ddCCMonth,
  #ddCCYear {
    height: 26px;
  }

  .LEAF.FORM #content {
    max-width: 930px;
    width: 97%;
    margin: 0 auto;
    min-height: 72vh;
  }

  .LEAF.FORM #content .form__left-silo {
    float: left;
    width: 100%;
    padding: 0 0.6em;
    font-size: 13px;
    line-height: 1.5em;
  }

  @media screen and (min-width: 768px) {
    .LEAF.FORM #content .form__left-silo {
      width: 30%;
      padding: 0;
    }
  }

  .LEAF.FORM #content .form__application-form {
    float: left;
    width: 100%;
  }

  @media screen and (min-width: 768px) {
    .LEAF.FORM #content .form__application-form {
      width: 70%;
    }
  }

  .lity.newsletter-iframe .lity-container {
    max-width: 750px;
  }

  .lity.newsletter-iframe .lity-iframe-container {
    padding-top: 85%;
    background-color: #fff;
  }

  @media screen and (max-width: 814px) {
    .lity.newsletter-iframe .lity-container,
    .lity.newsletter-iframe .lity-content,
    .lity.newsletter-iframe .lity-iframe-container {
      width: 100%;
      height: 100%;
      max-width: initial !important;
      max-height: initial !important;
      padding-top: 0;
    }

    .lity.newsletter-iframe .lity-close {
      top: 0;
    }
  }

  @media screen and (max-width: 1099px), screen and (max-height: 700px) {
    .lity.newsletter-iframe .lity-close {
      top: 0 !important;
      right: 0 !important;
    }
  }

  @media (orientation: landscape) {
    .lity.newsletter-iframe .lity-wrap {
      overflow: scroll;
    }
  }

  .EMAILSIGNUP #content,
  .EMAILSIGNUPCONFIRMATION #content {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0;
    margin: 0 !important;
  }

  .OUTDOOR.newsletter-popup__banner {
    background-image: url("//images-dynamic-arcteryx.imgix.net/misc/email-signup/email-popup-outdoor.jpg");
  }

  .URBAN.newsletter-popup__banner {
    background-image: url("//images-dynamic-arcteryx.imgix.net/misc/email-signup/email-popup-veilance.jpg");
  }

  .SALE.newsletter-popup__banner {
    background-image: url("//images-dynamic-arcteryx.imgix.net/misc/email-signup/email-popup-outlet.jpg");
  }

  .newsletter-popup__banner {
    max-width: 100%;
    min-height: 0;
    max-height: 180px;
    height: 180px;
    position: relative;
    padding: 0;
    background-position: center;
    background-size: cover;
  }

  @media screen and (min-width: 930px) {
    .newsletter-popup__banner {
      max-height: 245px;
      height: 245px;
    }
  }

  @media screen and (min-width: 1066px) {
    .newsletter-popup__banner {
      max-height: 290px;
      height: 290px;
    }
  }

  @media screen and (min-width: 1301px) {
    .newsletter-popup__banner {
      max-height: 250px;
      height: 250px;
    }
  }

  @media screen and (min-width: 1460px) {
    .newsletter-popup__banner {
      max-height: 350px;
      height: 350px;
    }
  }

  @media screen and (min-width: 1550px) {
    .newsletter-popup__banner {
      max-height: 400px;
      height: 400px;
    }
  }

  @media screen and (max-width: 479px) {
    .newsletter-popup__banner {
      min-height: 100px;
      height: auto;
    }
  }

  .newsletter-success {
    height: auto;
    background: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin: 40px auto 100px;
    padding: 0;
  }

  @media screen and (max-width: 749px) {
    .newsletter-success {
      border: 0;
      width: 100%;
    }
  }

  .newsletter-success .inner-container {
    text-align: center;
    margin: 0 auto;
  }

  @media screen and (max-width: 749px) {
    .newsletter-success .inner-container {
      max-width: 93%;
      padding: 30px 0 0;
      margin: 0 auto;
    }
  }

  .newsletter-success .inner-container p {
    color: #565656;
    text-transform: none;
    font-size: 14px;
    line-height: 1.5;
  }

  .newsletter-success .inner-container .jp-launch {
    display: none;
  }

  .JP-LAUNCH .newsletter-success .inner-container .default {
    display: none;
  }

  .JP-LAUNCH .newsletter-success .inner-container .jp-launch {
    display: block;
  }

  .newsletter-success .newsletter-success__close-and-continue {
    display: none;
    text-decoration: underline;
    text-transform: uppercase !important;
    cursor: pointer;
    margin-top: 2em !important;
  }

  .is-iframe .newsletter-success .newsletter-success__close-and-continue {
    display: block;
  }

  #content .newsletter-popup__content {
    margin: 1em 2% 0;
  }

  @media screen and (min-width: 750px) {
    #content .newsletter-popup__content {
      margin: 40px auto 0;
    }

    .URBAN #content .newsletter-popup__content {
      margin: 40px auto 100px;
    }
  }

  #content .newsletter-popup__content h1 {
    font-size: 24px;
    line-height: 1em;
    margin: 0 0 15px 0;
  }

  @media screen and (min-width: 750px) {
    #content .newsletter-popup__content h1 {
      font-size: 29px;
    }
  }

  #content .newsletter-popup__content p {
    font-size: 15px;
    line-height: 1.5em;
    margin: 0 auto 30px;
    max-width: 650px;
  }

  @media screen and (max-width: 413px) {
    #content .newsletter-popup__content p {
      font-size: 14px;
    }
  }

  #content .newsletter-popup__content a {
    font-style: italic;
    text-decoration: underline !important;
  }

  #content .newsletter-popup__content h1,
  #content .newsletter-popup__content p {
    text-align: center;
  }

  #content .newsletter-popup__content form {
    padding: 0 !important;
  }

  #content .newsletter-popup__content form .lft-align {
    margin-bottom: 20px;
  }

  #content .newsletter-popup__content form #EmailAddress-error {
    color: #9d1d1d;
    padding: 2px;
    font-style: italic;
  }

  @media screen and (max-width: 413px) {
    #content .newsletter-popup__content form p {
      font-size: 13px;
    }
  }

  #content .newsletter-popup__content .errormessage {
    background: #fbb;
    border: 1px solid #900;
    color: #300;
    font-weight: bold;
    border-radius: 2px;
    margin: 5px auto 15px;
    padding: 10px;
    width: 100%;
    max-width: 430px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  #content .newsletter-popup__content #btnSubmit {
    padding-left: 50px;
  }

  .URBAN #content .newsletter-popup__content #btnSubmit {
    padding-left: 30px;
  }

  #frameService {
    border: 0px;
    -webkit-box-shadow: none;
    box-shadow: none;
    min-width: 100%;
    overflow: hidden;
    width: 1px;
  }

  .JP #frameService {
    height: 2000px !important;
  }

  .customer-form.URBAN {
    background-color: #fff;
  }

  .CHECKOUT form.customer-form {
    max-width: initial;
  }

  #checkoutMain .form-row {
    max-width: 100%;
  }

  #checkoutMain .form-row input,
  #checkoutMain .form-row select {
    width: 84%;
    max-width: initial;
  }

  #mainContent .form-title h1,
  #mainContent .form-title p {
    text-align: left;
  }

  .OUTDOORRETURNS form,
  .VEILANCERETURNS form {
    max-width: 100%;
  }

  form.return-form,
  form.customer-form,
  form.profile-form,
  .pro-apply .customer-form,
  form.newsletter-thankyou {
    display: block;
    padding-left: 0.6em;
    padding-right: 0.6em;
    margin: 0 auto;
    max-width: none;
    width: 100%;
  }

  @media screen and (max-width: 929px) {
    form.return-form,
    form.customer-form,
    form.profile-form,
    .pro-apply .customer-form,
    form.newsletter-thankyou {
      padding-top: 40px;
    }
  }

  form.return-form .form-title h1,
  form.return-form .form-title h2,
  form.return-form .form-title p,
  form.customer-form .form-title h1,
  form.customer-form .form-title h2,
  form.customer-form .form-title p,
  form.profile-form .form-title h1,
  form.profile-form .form-title h2,
  form.profile-form .form-title p,
  .pro-apply .customer-form .form-title h1,
  .pro-apply .customer-form .form-title h2,
  .pro-apply .customer-form .form-title p,
  form.newsletter-thankyou .form-title h1,
  form.newsletter-thankyou .form-title h2,
  form.newsletter-thankyou .form-title p {
    text-align: center;
  }

  form.return-form *,
  form.customer-form *,
  form.profile-form *,
  .pro-apply .customer-form *,
  form.newsletter-thankyou * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  form.return-form input,
  form.return-form select,
  form.return-form textarea,
  form.customer-form input,
  form.customer-form select,
  form.customer-form textarea,
  form.profile-form input,
  form.profile-form select,
  form.profile-form textarea,
  .pro-apply .customer-form input,
  .pro-apply .customer-form select,
  .pro-apply .customer-form textarea,
  form.newsletter-thankyou input,
  form.newsletter-thankyou select,
  form.newsletter-thankyou textarea {
    font-family: var(--font-helvetica);
  }

  #content form.return-form p,
  #content form.customer-form p,
  #content form.profile-form p,
  #content .pro-apply .customer-form p,
  #content form.newsletter-thankyou p {
    max-width: 650px;
    margin: 0 auto 1.5em;
  }

  #content form.return-form a,
  #content form.customer-form a,
  #content form.profile-form a,
  #content .pro-apply .customer-form a,
  #content form.newsletter-thankyou a {
    text-decoration: underline;
  }

  @media screen and (max-width: 767px) {
    form.return-form,
    form.customer-form,
    form.profile-form,
    .pro-apply .customer-form,
    form.newsletter-thankyou {
      margin: 0 auto;
    }
  }

  form.return-form ul li,
  form.customer-form ul li,
  form.profile-form ul li,
  .pro-apply .customer-form ul li,
  form.newsletter-thankyou ul li {
    font-weight: 500;
    font-size: 16px;
  }

  form.return-form ul li:first-child,
  form.customer-form ul li:first-child,
  form.profile-form ul li:first-child,
  .pro-apply .customer-form ul li:first-child,
  form.newsletter-thankyou ul li:first-child {
    font-weight: 600;
    font-size: 14px;
    text-decoration: underline;
  }

  form.return-form .form-group,
  form.customer-form .form-group,
  form.profile-form .form-group,
  .pro-apply .customer-form .form-group,
  form.newsletter-thankyou .form-group {
    border: 1px solid lightgrey;
    margin: 1em auto;
    padding: 1em 1em 0;
  }

  form.return-form .form-row,
  form.customer-form .form-row,
  form.profile-form .form-row,
  .pro-apply .customer-form .form-row,
  form.newsletter-thankyou .form-row {
    font-size: 15px;
    padding: 0 0 0.8em 0;
    width: 100%;
    margin: 0 auto;
    //max-width: 430px;
    height: auto;
    display: block;
    position: relative;
    clear: both;
  }

  form.return-form .form-row:last-of-type,
  form.customer-form .form-row:last-of-type,
  form.profile-form .form-row:last-of-type,
  .pro-apply .customer-form .form-row:last-of-type,
  form.newsletter-thankyou .form-row:last-of-type {
    padding: 0;
  }

  form.return-form .form-title,
  form.customer-form .form-title,
  form.profile-form .form-title,
  .pro-apply .customer-form .form-title,
  form.newsletter-thankyou .form-title {
    font-size: 15px;
    padding: 0 0 3em 0;
    width: auto;
    max-width: 650px;
    height: auto;
    display: block;
    position: relative;
    clear: both;
    margin: auto;
  }

  @media screen and (max-width: 479px) {
    form.return-form .form-title,
    form.customer-form .form-title,
    form.profile-form .form-title,
    .pro-apply .customer-form .form-title,
    form.newsletter-thankyou .form-title {
      width: 95%;
    }
  }

  .CONTACT form.return-form .form-title p,
  .CONTACT form.customer-form .form-title p,
  .CONTACT form.profile-form .form-title p,
  .CONTACT .pro-apply .customer-form .form-title p,
  .CONTACT form.newsletter-thankyou .form-title p {
    margin: 0 auto 3em !important;
  }

  @media screen and (max-width: 479px) {
    form.return-form .form-title,
    form.customer-form .form-title,
    form.profile-form .form-title,
    .pro-apply .customer-form .form-title,
    form.newsletter-thankyou .form-title {
      width: 95%;
    }
  }

  form.return-form .form-row.file,
  form.customer-form .form-row.file,
  form.profile-form .form-row.file,
  .pro-apply .customer-form .form-row.file,
  form.newsletter-thankyou .form-row.file {
    padding-left: 0;
  }

  form.return-form .form-input-file,
  form.customer-form .form-input-file,
  form.profile-form .form-input-file,
  .pro-apply .customer-form .form-input-file,
  form.newsletter-thankyou .form-input-file {
    border: 1px solid #999;
    background: #fff;
    border-radius: 3px;
    padding: 20px 20px 30px 20px;
    margin: 3px auto;
    color: #333;
    font-size: 16px;
    width: 100%;
    max-width: 430px;
    margin-bottom: 0.8em;
    font-size: 14px;
    text-align: center;
  }

  form.return-form .form-input-file *,
  form.customer-form .form-input-file *,
  form.profile-form .form-input-file *,
  .pro-apply .customer-form .form-input-file *,
  form.newsletter-thankyou .form-input-file * {
    font-size: 14px;
    font-style: italic;
  }

  form.return-form .form-input-file.drag-active,
  form.customer-form .form-input-file.drag-active,
  form.profile-form .form-input-file.drag-active,
  .pro-apply .customer-form .form-input-file.drag-active,
  form.newsletter-thankyou .form-input-file.drag-active {
    border: 2px dashed #42d83f;
    cursor: copy;
  }

  form.return-form .form-input-file.drag-invalid,
  form.customer-form .form-input-file.drag-invalid,
  form.profile-form .form-input-file.drag-invalid,
  .pro-apply .customer-form .form-input-file.drag-invalid,
  form.newsletter-thankyou .form-input-file.drag-invalid {
    border: 2px dashed #a30200;
    cursor: copy;
  }

  form.return-form .form-input-file span.fileName,
  form.customer-form .form-input-file span.fileName,
  form.profile-form .form-input-file span.fileName,
  .pro-apply .customer-form .form-input-file span.fileName,
  form.newsletter-thankyou .form-input-file span.fileName {
    margin: 8px 0;
    display: inline-block;
    font-style: normal;
    color: var(--colour-black);
  }

  form.return-form .form-input-file span.removeFile,
  form.customer-form .form-input-file span.removeFile,
  form.profile-form .form-input-file span.removeFile,
  .pro-apply .customer-form .form-input-file span.removeFile,
  form.newsletter-thankyou .form-input-file span.removeFile {
    margin-left: 5px;
    display: inline-block;
    color: #a30200;
    font-weight: bold;
    cursor: pointer;
  }

  form.return-form .form-input-file input[type="file"],
  form.customer-form .form-input-file input[type="file"],
  form.profile-form .form-input-file input[type="file"],
  .pro-apply .customer-form .form-input-file input[type="file"],
  form.newsletter-thankyou .form-input-file input[type="file"] {
    border: 0;
    clip: rect(0, 0, 0, 0);
    overflow: hidden;
    padding: 10px;
    position: relative;
    white-space: nowrap;
    margin: 0 0 1em;
  }

  @media screen and (max-width: 767px) {
    form.return-form .form-input-file input[type="file"],
    form.customer-form .form-input-file input[type="file"],
    form.profile-form .form-input-file input[type="file"],
    .pro-apply .customer-form .form-input-file input[type="file"],
    form.newsletter-thankyou .form-input-file input[type="file"] {
      border: 1px solid var(--colour-black);
    }
  }

  form.return-form .form-input-file .warning--file-size,
  form.customer-form .form-input-file .warning--file-size,
  form.profile-form .form-input-file .warning--file-size,
  .pro-apply .customer-form .form-input-file .warning--file-size,
  form.newsletter-thankyou .form-input-file .warning--file-size {
    color: #a30200;
  }

  form.return-form .form-input-file .file-input-overlay,
  form.customer-form .form-input-file .file-input-overlay,
  form.profile-form .form-input-file .file-input-overlay,
  .pro-apply .customer-form .form-input-file .file-input-overlay,
  form.newsletter-thankyou .form-input-file .file-input-overlay {
    color: #333;
    height: 10px;
    position: relative;
    font-size: 14px;
    font-style: normal;
    cursor: pointer;
    display: inline-block;
    margin-bottom: 15px;
  }

  form.return-form .form-input-file .file-input-overlay:before,
  form.customer-form .form-input-file .file-input-overlay:before,
  form.profile-form .form-input-file .file-input-overlay:before,
  .pro-apply .customer-form .form-input-file .file-input-overlay:before,
  form.newsletter-thankyou .form-input-file .file-input-overlay:before {
    content: url(../graphics/attach.svg);
    position: absolute;
    margin-top: -3px;
    width: 20px;
    height: 20px;
    margin-left: -26px;
    cursor: pointer;
    left: 0;
  }

  form.return-form .lft-align,
  form.customer-form .lft-align,
  form.profile-form .lft-align,
  .pro-apply .customer-form .lft-align,
  form.newsletter-thankyou .lft-align {
    display: inline-block;
    clear: both;
    width: 100%;
    max-width: 420px;
    margin-top: -10px;
    margin-bottom: 15px;
  }

  form.return-form .lft-align.last-input,
  form.customer-form .lft-align.last-input,
  form.profile-form .lft-align.last-input,
  .pro-apply .customer-form .lft-align.last-input,
  form.newsletter-thankyou .lft-align.last-input {
    margin-top: 0;
  }

  form.return-form .lft-align a,
  form.return-form .lft-align span,
  form.customer-form .lft-align a,
  form.customer-form .lft-align span,
  form.profile-form .lft-align a,
  form.profile-form .lft-align span,
  .pro-apply .customer-form .lft-align a,
  .pro-apply .customer-form .lft-align span,
  form.newsletter-thankyou .lft-align a,
  form.newsletter-thankyou .lft-align span {
    font-style: italic;
    font-size: 14px !important;
    text-decoration: underline !important;
    cursor: pointer;
  }

  form.return-form .lft-align a.required-field,
  form.return-form .lft-align span.required-field,
  form.customer-form .lft-align a.required-field,
  form.customer-form .lft-align span.required-field,
  form.profile-form .lft-align a.required-field,
  form.profile-form .lft-align span.required-field,
  .pro-apply .customer-form .lft-align a.required-field,
  .pro-apply .customer-form .lft-align span.required-field,
  form.newsletter-thankyou .lft-align a.required-field,
  form.newsletter-thankyou .lft-align span.required-field {
    text-decoration: none !important;
  }

  form.return-form .lft-align input.left-box,
  form.customer-form .lft-align input.left-box,
  form.profile-form .lft-align input.left-box,
  .pro-apply .customer-form .lft-align input.left-box,
  form.newsletter-thankyou .lft-align input.left-box {
    float: left;
    margin-right: 5px;
    margin-top: 2px;
  }

  form.return-form .lft-align label,
  form.customer-form .lft-align label,
  form.profile-form .lft-align label,
  .pro-apply .customer-form .lft-align label,
  form.newsletter-thankyou .lft-align label {
    display: inline;
    width: 90%;
  }

  form.return-form label,
  form.customer-form label,
  form.profile-form label,
  .pro-apply .customer-form label,
  form.newsletter-thankyou label {
    padding: 2px 0 4px 0;
    max-width: 100% !important;
    width: auto !important;
  }

  form.return-form .last-input,
  form.customer-form .last-input,
  form.profile-form .last-input,
  .pro-apply .customer-form .last-input,
  form.newsletter-thankyou .last-input {
    padding-bottom: 0.8em;
  }

  form.return-form .required-field,
  form.customer-form .required-field,
  form.profile-form .required-field,
  .pro-apply .customer-form .required-field,
  form.newsletter-thankyou .required-field {
    color: #a30200;
    margin-left: 0;
    font-size: 1.5em;
  }

  form.return-form span.field-anchor,
  form.customer-form span.field-anchor,
  form.profile-form span.field-anchor,
  .pro-apply .customer-form span.field-anchor,
  form.newsletter-thankyou span.field-anchor {
    clear: both;
    display: block;
  }

  form.return-form .field-validation-error,
  form.return-form .field-validation-error span,
  form.return-form span[data-valmsg-for],
  form.customer-form .field-validation-error,
  form.customer-form .field-validation-error span,
  form.customer-form span[data-valmsg-for],
  form.profile-form .field-validation-error,
  form.profile-form .field-validation-error span,
  form.profile-form span[data-valmsg-for],
  .pro-apply .customer-form .field-validation-error,
  .pro-apply .customer-form .field-validation-error span,
  .pro-apply .customer-form span[data-valmsg-for],
  form.newsletter-thankyou .field-validation-error,
  form.newsletter-thankyou .field-validation-error span,
  form.newsletter-thankyou span[data-valmsg-for] {
    color: #9d1d1d;
    padding: 2px;
    font-style: italic;
    font-size: 0.9em;
    line-height: 1.1em;
  }

  form.return-form .form-row p,
  form.customer-form .form-row p,
  form.profile-form .form-row p,
  .pro-apply .customer-form .form-row p,
  form.newsletter-thankyou .form-row p {
    padding: 0;
    margin: 0;
    font-size: 0.9em;
    color: #333;
  }

  form.return-form .form-row p label,
  form.customer-form .form-row p label,
  form.profile-form .form-row p label,
  .pro-apply .customer-form .form-row p label,
  form.newsletter-thankyou .form-row p label {
    display: inline-block;
  }

  form.return-form p label:after,
  form.customer-form p label:after,
  form.profile-form p label:after,
  .pro-apply .customer-form p label:after,
  form.newsletter-thankyou p label:after {
    content: none;
  }

  form.return-form .form-input-select,
  form.customer-form .form-input-select,
  form.profile-form .form-input-select,
  .pro-apply .customer-form .form-input-select,
  form.newsletter-thankyou .form-input-select {
    padding-bottom: 3px;
    display: block;
    vertical-align: middle;
    clear: both;
    margin: 0;
    line-height: 0;
    width: 100%;
    height: auto;
  }

  form.return-form .form-input-select select,
  form.customer-form .form-input-select select,
  form.profile-form .form-input-select select,
  .pro-apply .customer-form .form-input-select select,
  form.newsletter-thankyou .form-input-select select,
  form.return-form select,
  form.customer-form select,
  form.profile-form select,
  .pro-apply .customer-form select,
  form.newsletter-thankyou select {
    border: 1px solid var(--dark-grey);
    border-radius: 0;
    height: 45px;
    width: 100%;
    max-width: none;
    padding: 0px 45px 0px 15px;
    color: var(--colour-black);
    font-size: 1rem;
    float: left;
    background: url(//images.arcteryx.com/foundation-ui/svgs/Select_Arrow.svg)
      96% center / 3% no-repeat rgb(255, 255, 255);
    appearance: none;
  }

  @media screen and (min-width: 480px) {
    form.return-form .form-input-select select,
    form.customer-form .form-input-select select,
    form.profile-form .form-input-select select,
    .pro-apply .customer-form .form-input-select select,
    form.newsletter-thankyou .form-input-select select {
      max-width: 430px;
    }
  }

  form.return-form .form-input-select span,
  form.customer-form .form-input-select span,
  form.profile-form .form-input-select span,
  .pro-apply .customer-form .form-input-select span,
  form.newsletter-thankyou .form-input-select span {
    line-height: 1em;
    font-size: 1em;
    display: block;
    padding: 0.7em 0;
    color: #666;
    font-style: italic;
    clear: both;
  }

  form.return-form
    form.customer-form
    .form-row
    .form-input-select
    #OtherSegmentField
    .form-input,
  form.customer-form
    form.customer-form
    .form-row
    .form-input-select
    #OtherSegmentField
    .form-input,
  form.profile-form
    form.customer-form
    .form-row
    .form-input-select
    #OtherSegmentField
    .form-input,
  .pro-apply
    .customer-form
    form.customer-form
    .form-row
    .form-input-select
    #OtherSegmentField
    .form-input,
  form.newsletter-thankyou
    form.customer-form
    .form-row
    .form-input-select
    #OtherSegmentField
    .form-input {
    height: 26px;
  }

  form.return-form #ReferralCodeField,
  form.customer-form #ReferralCodeField,
  form.profile-form #ReferralCodeField,
  .pro-apply .customer-form #ReferralCodeField,
  form.newsletter-thankyou #ReferralCodeField {
    display: none;
  }

  form.return-form #OtherSegmentField,
  form.customer-form #OtherSegmentField,
  form.profile-form #OtherSegmentField,
  .pro-apply .customer-form #OtherSegmentField,
  form.newsletter-thankyou #OtherSegmentField {
    display: none;
    padding: 8px 0 0 0;
  }

  form.return-form #OtherSegmentField label,
  form.customer-form #OtherSegmentField label,
  form.profile-form #OtherSegmentField label,
  .pro-apply .customer-form #OtherSegmentField label,
  form.newsletter-thankyou #OtherSegmentField label {
    display: inline-block;
    padding-bottom: 2px;
    clear: left;
  }

  form.return-form #OtherSegmentField span,
  form.customer-form #OtherSegmentField span,
  form.profile-form #OtherSegmentField span,
  .pro-apply .customer-form #OtherSegmentField span,
  form.newsletter-thankyou #OtherSegmentField span {
    display: none;
  }

  form.return-form #OtherSegmentField span.required-field,
  form.customer-form #OtherSegmentField span.required-field,
  form.profile-form #OtherSegmentField span.required-field,
  .pro-apply .customer-form #OtherSegmentField span.required-field,
  form.newsletter-thankyou #OtherSegmentField span.required-field {
    display: inline-block;
    color: #a30200;
    margin: 0 0 0 4px;
    font-size: 1.5em;
    padding: 0px;
  }

  form.return-form #OtherSegmentField .form-input,
  form.customer-form #OtherSegmentField .form-input,
  form.profile-form #OtherSegmentField .form-input,
  .pro-apply .customer-form #OtherSegmentField .form-input,
  form.newsletter-thankyou #OtherSegmentField .form-input {
    display: block;
    position: relative;
    clear: both;
    margin: 0;
    line-height: 0;
    width: 100%;
    height: auto;
    position: relative;
  }

  form.return-form #OtherSegmentField .form-input input,
  form.customer-form #OtherSegmentField .form-input input,
  form.profile-form #OtherSegmentField .form-input input,
  .pro-apply .customer-form #OtherSegmentField .form-input input,
  form.newsletter-thankyou #OtherSegmentField .form-input input {
    border: 1px solid var(--dark-grey);
    height: 44px;
    width: 100%;
    background: #fff;
    border-radius: 3px;
    padding-left: 4px;
    color: #333;
  }

  form.return-form
    #OtherSegmentField
    .form-input
    #checkoutMain
    .form-input
    input,
  form.customer-form
    #OtherSegmentField
    .form-input
    #checkoutMain
    .form-input
    input,
  form.profile-form
    #OtherSegmentField
    .form-input
    #checkoutMain
    .form-input
    input,
  .pro-apply
    .customer-form
    #OtherSegmentField
    .form-input
    #checkoutMain
    .form-input
    input,
  form.newsletter-thankyou
    #OtherSegmentField
    .form-input
    #checkoutMain
    .form-input
    input {
    width: 84%;
    max-width: initial !important;
  }

  form.return-form .field-validation-valid + .form-input input[type="text"],
  form.return-form .field-validation-valid + .form-input input[type="number"],
  form.return-form .field-validation-valid + .form-input select,
  form.customer-form .field-validation-valid + .form-input input[type="text"],
  form.customer-form .field-validation-valid + .form-input input[type="number"],
  form.customer-form .field-validation-valid + .form-input select,
  form.profile-form .field-validation-valid + .form-input input[type="text"],
  form.profile-form .field-validation-valid + .form-input input[type="number"],
  form.profile-form .field-validation-valid + .form-input select,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input
    input[type="text"],
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input
    input[type="number"],
  .pro-apply .customer-form .field-validation-valid + .form-input select,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input
    input[type="text"],
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input
    input[type="number"],
  form.newsletter-thankyou .field-validation-valid + .form-input select {
    border: 1px solid #3fa755;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
  }

  form.return-form input[type="text"]:focus,
  form.return-form input[type="number"]:focus,
  form.customer-form input[type="text"]:focus,
  form.customer-form input[type="number"]:focus,
  form.profile-form input[type="text"]:focus,
  form.profile-form input[type="number"]:focus,
  .pro-apply .customer-form input[type="text"]:focus,
  .pro-apply .customer-form input[type="number"]:focus,
  form.newsletter-thankyou input[type="text"]:focus,
  form.newsletter-thankyou input[type="number"]:focus {
    border: 2px solid #bcd9e7;
    background: #f7f7f7;
    border-radius: 3px;
  }

  form.return-form .field-validation-error + .form-input input[type="text"],
  form.return-form .field-validation-error + .form-input input[type="number"],
  form.customer-form .field-validation-error + .form-input input[type="text"],
  form.customer-form .field-validation-error + .form-input input[type="number"],
  form.profile-form .field-validation-error + .form-input input[type="text"],
  form.profile-form .field-validation-error + .form-input input[type="number"],
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input
    input[type="text"],
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input
    input[type="number"],
  form.newsletter-thankyou
    .field-validation-error
    + .form-input
    input[type="text"],
  form.newsletter-thankyou
    .field-validation-error
    + .form-input
    input[type="number"] {
    border: 1px solid #9d1d1d;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
  }

  form.return-form .form-input-selection,
  form.customer-form .form-input-selection,
  form.profile-form .form-input-selection,
  .pro-apply .customer-form .form-input-selection,
  form.newsletter-thankyou .form-input-selection {
    display: block;
    vertical-align: middle;
    position: relative;
    clear: both;
    margin: 0;
    line-height: 0;
    width: 100%;
    height: 60px;
  }

  form.return-form .form-input,
  form.customer-form .form-input,
  form.profile-form .form-input,
  .pro-apply .customer-form .form-input,
  form.newsletter-thankyou .form-input {
    display: block;
    vertical-align: middle;
    clear: both;
    margin: 0;
    line-height: 0;
    width: 100%;
    height: 60px;
    position: relative;
  }

  form.return-form .form-input input,
  form.customer-form .form-input input,
  form.profile-form .form-input input,
  .pro-apply .customer-form .form-input input,
  form.newsletter-thankyou .form-input input {
    width: 100%;
    max-width: 430px;
    font-size: 1.3em;
    float: left;
  }

  form.return-form .form-input span,
  form.customer-form .form-input span,
  form.profile-form .form-input span,
  .pro-apply .customer-form .form-input span,
  form.newsletter-thankyou .form-input span {
    line-height: 0.9em;
    font-size: 1em;
    display: block;
    padding: 4px 0;
  }

  form.return-form .form-input select.sml-select,
  form.customer-form .form-input select.sml-select,
  form.profile-form .form-input select.sml-select,
  .pro-apply .customer-form .form-input select.sml-select,
  form.newsletter-thankyou .form-input select.sml-select {
    width: 100%;
    max-width: 430px;
    float: left;
  }

  form.return-form .form-input-sml,
  form.customer-form .form-input-sml,
  form.profile-form .form-input-sml,
  .pro-apply .customer-form .form-input-sml,
  form.newsletter-thankyou .form-input-sml {
    display: block;
    position: relative;
    vertical-align: middle;
    clear: both;
    margin: 0;
    line-height: 0;
    width: 100%;
    height: 50px;
  }

  form.return-form .form-input-sml input.sml-input,
  form.customer-form .form-input-sml input.sml-input,
  form.profile-form .form-input-sml input.sml-input,
  .pro-apply .customer-form .form-input-sml input.sml-input,
  form.newsletter-thankyou .form-input-sml input.sml-input {
    width: 152px;
  }

  form.return-form .form-input-sml span,
  form.customer-form .form-input-sml span,
  form.profile-form .form-input-sml span,
  .pro-apply .customer-form .form-input-sml span,
  form.newsletter-thankyou .form-input-sml span {
    line-height: 0.9em;
    font-size: 1em;
    display: block;
    padding: 4px 0;
  }

  form.return-form .form-input-sml select.sml-select,
  form.customer-form .form-input-sml select.sml-select,
  form.profile-form .form-input-sml select.sml-select,
  .pro-apply .customer-form .form-input-sml select.sml-select,
  form.newsletter-thankyou .form-input-sml select.sml-select {
    width: 86%;
    float: left;
  }

  form.return-form .form-input-sml input.sml-input,
  form.customer-form .form-input-sml input.sml-input,
  form.profile-form .form-input-sml input.sml-input,
  .pro-apply .customer-form .form-input-sml input.sml-input,
  form.newsletter-thankyou .form-input-sml input.sml-input {
    width: 100%;
    max-width: 430px;
    float: left;
  }

  form.return-form .form-input-textarea,
  form.customer-form .form-input-textarea,
  form.profile-form .form-input-textarea,
  .pro-apply .customer-form .form-input-textarea,
  form.newsletter-thankyou .form-input-textarea {
    display: block;
    position: relative;
    clear: both;
    margin: 0;
    line-height: 0;
    width: 100%;
    height: 102px;
  }

  form.return-form .form-input-textarea span,
  form.customer-form .form-input-textarea span,
  form.profile-form .form-input-textarea span,
  .pro-apply .customer-form .form-input-textarea span,
  form.newsletter-thankyou .form-input-textarea span {
    line-height: 0.9em;
    font-size: 1em;
    display: block;
    padding: 4px 0;
  }

  form.return-form input[type="email"],
  form.return-form input[type="tel"],
  form.return-form input[type="text"],
  form.return-form input[type="date"],
  form.return-form input[type="password"],
  form.return-form input[type="number"],
  form.customer-form input[type="email"],
  form.customer-form input[type="tel"],
  form.customer-form input[type="text"],
  form.customer-form input[type="date"],
  form.customer-form input[type="password"],
  form.customer-form input[type="number"],
  form.profile-form input[type="email"],
  form.profile-form input[type="tel"],
  form.profile-form input[type="text"],
  form.profile-form input[type="date"],
  form.profile-form input[type="password"],
  form.profile-form input[type="number"],
  .pro-apply .customer-form input[type="email"],
  .pro-apply .customer-form input[type="tel"],
  .pro-apply .customer-form input[type="text"],
  .pro-apply .customer-form input[type="date"],
  .pro-apply .customer-form input[type="password"],
  .pro-apply .customer-form input[type="number"],
  form.newsletter-thankyou input[type="email"],
  form.newsletter-thankyou input[type="tel"],
  form.newsletter-thankyou input[type="text"],
  form.newsletter-thankyou input[type="date"],
  form.newsletter-thankyou input[type="password"],
  form.newsletter-thankyou input[type="number"] {
    border: 1px solid var(--dark-grey);
    height: 45px;
    background: var(--colour-white);
    border-radius: 0;
    padding: 0px 45px 0px 15px;
    margin: 0;
    font-size: 1rem;
    color: var(--colour-black);
  }

  form.return-form input[type="email"],
  form.return-form input[type="tel"],
  form.return-form input[type="text"],
  form.return-form input[type="date"],
  form.return-form input[type="password"],
  form.return-form input[type="number"],
  form.customer-form input[type="email"],
  form.customer-form input[type="tel"],
  form.customer-form input[type="text"],
  form.customer-form input[type="date"],
  form.customer-form input[type="password"],
  form.customer-form input[type="number"],
  form.profile-form input[type="email"],
  form.profile-form input[type="tel"],
  form.profile-form input[type="text"],
  form.profile-form input[type="date"],
  form.profile-form input[type="password"],
  form.profile-form input[type="number"],
  .pro-apply .customer-form input[type="email"],
  .pro-apply .customer-form input[type="tel"],
  .pro-apply .customer-form input[type="text"],
  .pro-apply .customer-form input[type="date"],
  .pro-apply .customer-form input[type="password"],
  .pro-apply .customer-form input[type="number"],
  form.newsletter-thankyou input[type="email"],
  form.newsletter-thankyou input[type="tel"],
  form.newsletter-thankyou input[type="text"],
  form.newsletter-thankyou input[type="date"],
  form.newsletter-thankyou input[type="password"],
  form.newsletter-thankyou input[type="number"] {
    -webkit-transition: all 0.45s ease-in-out;
    transition: all 0.45s ease-in-out;
    font-size: 16px;
    line-height: 1.4em;
    vertical-align: middle;
  }

  form.return-form input[type="email"]:focus,
  form.return-form input[type="text"]:focus,
  form.return-form input[type="tel"]:focus,
  form.return-form input[type="date"]:focus,
  form.return-form input[type="password"]:focus,
  form.return-form input[type="number"]:focus,
  form.customer-form input[type="email"]:focus,
  form.customer-form input[type="text"]:focus,
  form.customer-form input[type="tel"]:focus,
  form.customer-form input[type="date"]:focus,
  form.customer-form input[type="password"]:focus,
  form.customer-form input[type="number"]:focus,
  form.profile-form input[type="email"]:focus,
  form.profile-form input[type="text"]:focus,
  form.profile-form input[type="tel"]:focus,
  form.profile-form input[type="date"]:focus,
  form.profile-form input[type="password"]:focus,
  form.profile-form input[type="number"]:focus,
  .pro-apply .customer-form input[type="email"]:focus,
  .pro-apply .customer-form input[type="text"]:focus,
  .pro-apply .customer-form input[type="tel"]:focus,
  .pro-apply .customer-form input[type="date"]:focus,
  .pro-apply .customer-form input[type="password"]:focus,
  .pro-apply .customer-form input[type="number"]:focus,
  form.newsletter-thankyou input[type="email"]:focus,
  form.newsletter-thankyou input[type="text"]:focus,
  form.newsletter-thankyou input[type="tel"]:focus,
  form.newsletter-thankyou input[type="date"]:focus,
  form.newsletter-thankyou input[type="password"]:focus,
  form.newsletter-thankyou input[type="number"]:focus {
    outline: none;
    border: 1px solid var(--focus-blue);
    background: var(--colour-white);
  }

  form.return-form .field-validation-valid + .form-input input[type="text"],
  form.return-form .field-validation-valid + .form-input input[type="email"],
  form.return-form .field-validation-valid + .form-input input[type="tel"],
  form.return-form .field-validation-valid + .form-input input[type="password"],
  form.return-form .field-validation-valid + .form-input input[type="number"],
  form.customer-form .field-validation-valid + .form-input input[type="text"],
  form.customer-form .field-validation-valid + .form-input input[type="email"],
  form.customer-form .field-validation-valid + .form-input input[type="tel"],
  form.customer-form
    .field-validation-valid
    + .form-input
    input[type="password"],
  form.customer-form .field-validation-valid + .form-input input[type="number"],
  form.profile-form .field-validation-valid + .form-input input[type="text"],
  form.profile-form .field-validation-valid + .form-input input[type="email"],
  form.profile-form .field-validation-valid + .form-input input[type="tel"],
  form.profile-form
    .field-validation-valid
    + .form-input
    input[type="password"],
  form.profile-form .field-validation-valid + .form-input input[type="number"],
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input
    input[type="text"],
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input
    input[type="email"],
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input
    input[type="tel"],
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input
    input[type="password"],
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input
    input[type="number"],
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input
    input[type="text"],
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input
    input[type="email"],
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input
    input[type="tel"],
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input
    input[type="password"],
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input
    input[type="number"] {
    border: 1px solid #3fa755;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    font-size: 16px;
    line-height: 1.4em;
    vertical-align: middle;
  }

  form.return-form
    .field-validation-valid
    + .form-input
    input[type="text"]:focus,
  form.return-form
    .field-validation-valid
    + .form-input
    input[type="email"]:focus,
  form.return-form
    .field-validation-valid
    + .form-input
    input[type="tel"]:focus,
  form.return-form
    .field-validation-valid
    + .form-input
    input[type="password"]:focus,
  form.return-form
    .field-validation-valid
    + .form-input
    input[type="number"]:focus,
  form.customer-form
    .field-validation-valid
    + .form-input
    input[type="text"]:focus,
  form.customer-form
    .field-validation-valid
    + .form-input
    input[type="email"]:focus,
  form.customer-form
    .field-validation-valid
    + .form-input
    input[type="tel"]:focus,
  form.customer-form
    .field-validation-valid
    + .form-input
    input[type="password"]:focus,
  form.customer-form
    .field-validation-valid
    + .form-input
    input[type="number"]:focus,
  form.profile-form
    .field-validation-valid
    + .form-input
    input[type="text"]:focus,
  form.profile-form
    .field-validation-valid
    + .form-input
    input[type="email"]:focus,
  form.profile-form
    .field-validation-valid
    + .form-input
    input[type="tel"]:focus,
  form.profile-form
    .field-validation-valid
    + .form-input
    input[type="password"]:focus,
  form.profile-form
    .field-validation-valid
    + .form-input
    input[type="number"]:focus,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input
    input[type="text"]:focus,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input
    input[type="email"]:focus,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input
    input[type="tel"]:focus,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input
    input[type="password"]:focus,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input
    input[type="number"]:focus,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input
    input[type="text"]:focus,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input
    input[type="email"]:focus,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input
    input[type="tel"]:focus,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input
    input[type="password"]:focus,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input
    input[type="number"]:focus {
    border: 2px solid #bcd9e7;
    background: #f7f7f7;
    border-radius: 3px;
    font-size: 16px;
    line-height: 1.4em;
    vertical-align: middle;
  }

  form.return-form .field-validation-valid + .form-input:after,
  form.customer-form .field-validation-valid + .form-input:after,
  form.profile-form .field-validation-valid + .form-input:after,
  .pro-apply .customer-form .field-validation-valid + .form-input:after,
  form.newsletter-thankyou .field-validation-valid + .form-input:after {
    content: url("//images.arcteryx.com/foundation-ui/forms/check.svg");
    display: block;
    width: 15px;
    height: 15px;
    right: -20px;
    top: 40%;
    position: absolute;
  }

  .CHECKOUT form.return-form .field-validation-valid + .form-input:after,
  .CHECKOUT form.customer-form .field-validation-valid + .form-input:after,
  .CHECKOUT form.profile-form .field-validation-valid + .form-input:after,
  .CHECKOUT
    .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input:after,
  .CHECKOUT
    form.newsletter-thankyou
    .field-validation-valid
    + .form-input:after {
    right: 20px;
  }

  @media screen and (max-width: 479px) {
    form.return-form .field-validation-valid + .form-input:after,
    form.customer-form .field-validation-valid + .form-input:after,
    form.profile-form .field-validation-valid + .form-input:after,
    .pro-apply .customer-form .field-validation-valid + .form-input:after,
    form.newsletter-thankyou .field-validation-valid + .form-input:after {
      top: 43%;
      right: 5%;
      left: auto;
      position: absolute;
    }
  }

  form.return-form .field-validation-error + .form-input input[type="text"],
  form.return-form .field-validation-error + .form-input input[type="email"],
  form.return-form .field-validation-error + .form-input input[type="tel"],
  form.return-form .field-validation-error + .form-input input[type="password"],
  form.return-form .field-validation-error + .form-input input[type="number"],
  form.return-form .field-validation-error + .form-input select,
  form.customer-form .field-validation-error + .form-input input[type="text"],
  form.customer-form .field-validation-error + .form-input input[type="email"],
  form.customer-form .field-validation-error + .form-input input[type="tel"],
  form.customer-form
    .field-validation-error
    + .form-input
    input[type="password"],
  form.customer-form .field-validation-error + .form-input input[type="number"],
  form.customer-form .field-validation-error + .form-input select,
  form.profile-form .field-validation-error + .form-input input[type="text"],
  form.profile-form .field-validation-error + .form-input input[type="email"],
  form.profile-form .field-validation-error + .form-input input[type="tel"],
  form.profile-form
    .field-validation-error
    + .form-input
    input[type="password"],
  form.profile-form .field-validation-error + .form-input input[type="number"],
  form.profile-form .field-validation-error + .form-input select,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input
    input[type="text"],
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input
    input[type="email"],
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input
    input[type="tel"],
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input
    input[type="password"],
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input
    input[type="number"],
  .pro-apply .customer-form .field-validation-error + .form-input select,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input
    input[type="text"],
  form.newsletter-thankyou
    .field-validation-error
    + .form-input
    input[type="email"],
  form.newsletter-thankyou
    .field-validation-error
    + .form-input
    input[type="tel"],
  form.newsletter-thankyou
    .field-validation-error
    + .form-input
    input[type="password"],
  form.newsletter-thankyou
    .field-validation-error
    + .form-input
    input[type="number"],
  form.newsletter-thankyou .field-validation-error + .form-input select {
    border: 1px solid #a30200;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    font-size: 16px;
    line-height: 1.4em;
    vertical-align: middle;
  }

  form.return-form
    .field-validation-error
    + .form-input
    input[type="text"]:focus,
  form.return-form
    .field-validation-error
    + .form-input
    input[type="email"]:focus,
  form.return-form
    .field-validation-error
    + .form-input
    input[type="tel"]:focus,
  form.return-form
    .field-validation-error
    + .form-input
    input[type="password"]:focus,
  form.return-form
    .field-validation-error
    + .form-input
    input[type="number"]:focus,
  form.customer-form
    .field-validation-error
    + .form-input
    input[type="text"]:focus,
  form.customer-form
    .field-validation-error
    + .form-input
    input[type="email"]:focus,
  form.customer-form
    .field-validation-error
    + .form-input
    input[type="tel"]:focus,
  form.customer-form
    .field-validation-error
    + .form-input
    input[type="password"]:focus,
  form.customer-form
    .field-validation-error
    + .form-input
    input[type="number"]:focus,
  form.profile-form
    .field-validation-error
    + .form-input
    input[type="text"]:focus,
  form.profile-form
    .field-validation-error
    + .form-input
    input[type="email"]:focus,
  form.profile-form
    .field-validation-error
    + .form-input
    input[type="tel"]:focus,
  form.profile-form
    .field-validation-error
    + .form-input
    input[type="password"]:focus,
  form.profile-form
    .field-validation-error
    + .form-input
    input[type="number"]:focus,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input
    input[type="text"]:focus,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input
    input[type="email"]:focus,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input
    input[type="tel"]:focus,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input
    input[type="password"]:focus,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input
    input[type="number"]:focus,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input
    input[type="text"]:focus,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input
    input[type="email"]:focus,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input
    input[type="tel"]:focus,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input
    input[type="password"]:focus,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input
    input[type="number"]:focus {
    border: 2px solid #bcd9e7;
    background: #f7f7f7;
    border-radius: 3px;
    font-size: 16px;
    line-height: 1.4em;
    vertical-align: middle;
  }

  form.return-form input[type="text"]:-moz-read-only,
  form.return-form input[type="email"]:-moz-read-only,
  form.return-form input[type="tel"]:-moz-read-only,
  form.return-form input[type="password"]:-moz-read-only,
  form.return-form input[type="number"]:-moz-read-only,
  form.customer-form input[type="text"]:-moz-read-only,
  form.customer-form input[type="email"]:-moz-read-only,
  form.customer-form input[type="tel"]:-moz-read-only,
  form.customer-form input[type="password"]:-moz-read-only,
  form.customer-form input[type="number"]:-moz-read-only,
  form.profile-form input[type="text"]:-moz-read-only,
  form.profile-form input[type="email"]:-moz-read-only,
  form.profile-form input[type="tel"]:-moz-read-only,
  form.profile-form input[type="password"]:-moz-read-only,
  form.profile-form input[type="number"]:-moz-read-only,
  .pro-apply .customer-form input[type="text"]:-moz-read-only,
  .pro-apply .customer-form input[type="email"]:-moz-read-only,
  .pro-apply .customer-form input[type="tel"]:-moz-read-only,
  .pro-apply .customer-form input[type="password"]:-moz-read-only,
  .pro-apply .customer-form input[type="number"]:-moz-read-only,
  form.newsletter-thankyou input[type="text"]:-moz-read-only,
  form.newsletter-thankyou input[type="email"]:-moz-read-only,
  form.newsletter-thankyou input[type="tel"]:-moz-read-only,
  form.newsletter-thankyou input[type="password"]:-moz-read-only,
  form.newsletter-thankyou input[type="number"]:-moz-read-only {
    color: #777;
    border: #aeaeae 1px solid;
    background-color: #ebebeb;
    pointer-events: none;
  }

  form.return-form input[type="text"]:read-only,
  form.return-form input[type="email"]:read-only,
  form.return-form input[type="tel"]:read-only,
  form.return-form input[type="password"]:read-only,
  form.return-form input[type="number"]:read-only,
  form.customer-form input[type="text"]:read-only,
  form.customer-form input[type="email"]:read-only,
  form.customer-form input[type="tel"]:read-only,
  form.customer-form input[type="password"]:read-only,
  form.customer-form input[type="number"]:read-only,
  form.profile-form input[type="text"]:read-only,
  form.profile-form input[type="email"]:read-only,
  form.profile-form input[type="tel"]:read-only,
  form.profile-form input[type="password"]:read-only,
  form.profile-form input[type="number"]:read-only,
  .pro-apply .customer-form input[type="text"]:read-only,
  .pro-apply .customer-form input[type="email"]:read-only,
  .pro-apply .customer-form input[type="tel"]:read-only,
  .pro-apply .customer-form input[type="password"]:read-only,
  .pro-apply .customer-form input[type="number"]:read-only,
  form.newsletter-thankyou input[type="text"]:read-only,
  form.newsletter-thankyou input[type="email"]:read-only,
  form.newsletter-thankyou input[type="tel"]:read-only,
  form.newsletter-thankyou input[type="password"]:read-only,
  form.newsletter-thankyou input[type="number"]:read-only {
    color: #777;
    border: #aeaeae 1px solid;
    background-color: #ebebeb;
    pointer-events: none;
  }

  form.return-form .field-validation-error + .form-input:after,
  form.return-form .input-validation-error + .form-input:after,
  form.customer-form .field-validation-error + .form-input:after,
  form.customer-form .input-validation-error + .form-input:after,
  form.profile-form .field-validation-error + .form-input:after,
  form.profile-form .input-validation-error + .form-input:after,
  .pro-apply .customer-form .field-validation-error + .form-input:after,
  .pro-apply .customer-form .input-validation-error + .form-input:after,
  form.newsletter-thankyou .field-validation-error + .form-input:after,
  form.newsletter-thankyou .input-validation-error + .form-input:after {
    content: url("//images.arcteryx.com/foundation-ui/forms/caution.svg");
    display: block;
    width: 15px;
    height: 15px;
    right: -20px;
    top: 40%;
    position: absolute;
  }

  .CHECKOUT form.return-form .field-validation-error + .form-input:after,
  .CHECKOUT form.return-form .input-validation-error + .form-input:after,
  .CHECKOUT form.customer-form .field-validation-error + .form-input:after,
  .CHECKOUT form.customer-form .input-validation-error + .form-input:after,
  .CHECKOUT form.profile-form .field-validation-error + .form-input:after,
  .CHECKOUT form.profile-form .input-validation-error + .form-input:after,
  .CHECKOUT
    .pro-apply
    .customer-form
    .field-validation-error
    + .form-input:after,
  .CHECKOUT
    .pro-apply
    .customer-form
    .input-validation-error
    + .form-input:after,
  .CHECKOUT
    form.newsletter-thankyou
    .field-validation-error
    + .form-input:after,
  .CHECKOUT
    form.newsletter-thankyou
    .input-validation-error
    + .form-input:after {
    right: 20px;
  }

  @media screen and (max-width: 479px) {
    form.return-form .field-validation-error + .form-input:after,
    form.return-form .input-validation-error + .form-input:after,
    form.customer-form .field-validation-error + .form-input:after,
    form.customer-form .input-validation-error + .form-input:after,
    form.profile-form .field-validation-error + .form-input:after,
    form.profile-form .input-validation-error + .form-input:after,
    .pro-apply .customer-form .field-validation-error + .form-input:after,
    .pro-apply .customer-form .input-validation-error + .form-input:after,
    form.newsletter-thankyou .field-validation-error + .form-input:after,
    form.newsletter-thankyou .input-validation-error + .form-input:after {
      top: 43%;
      right: 5%;
      left: auto;
      position: absolute;
    }
  }

  form.return-form .field-validation-valid + .form-input-sml input[type="text"],
  form.return-form
    .field-validation-valid
    + .form-input-sml
    input[type="number"],
  form.customer-form
    .field-validation-valid
    + .form-input-sml
    input[type="text"],
  form.customer-form
    .field-validation-valid
    + .form-input-sml
    input[type="number"],
  form.profile-form
    .field-validation-valid
    + .form-input-sml
    input[type="text"],
  form.profile-form
    .field-validation-valid
    + .form-input-sml
    input[type="number"],
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-sml
    input[type="text"],
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-sml
    input[type="number"],
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input-sml
    input[type="text"],
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input-sml
    input[type="number"] {
    border: 1px solid #3fa755;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
  }

  form.return-form
    .field-validation-valid
    + .form-input-sml
    input[type="text"]:focus,
  form.return-form
    .field-validation-valid
    + .form-input-sml
    input[type="number"]:focus,
  form.customer-form
    .field-validation-valid
    + .form-input-sml
    input[type="text"]:focus,
  form.customer-form
    .field-validation-valid
    + .form-input-sml
    input[type="number"]:focus,
  form.profile-form
    .field-validation-valid
    + .form-input-sml
    input[type="text"]:focus,
  form.profile-form
    .field-validation-valid
    + .form-input-sml
    input[type="number"]:focus,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-sml
    input[type="text"]:focus,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-sml
    input[type="number"]:focus,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input-sml
    input[type="text"]:focus,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input-sml
    input[type="number"]:focus {
    border: 2px solid #bcd9e7;
    background: #f7f7f7;
    border-radius: 3px;
  }

  form.return-form .field-validation-valid + .form-input-sml:after,
  form.customer-form .field-validation-valid + .form-input-sml:after,
  form.profile-form .field-validation-valid + .form-input-sml:after,
  .pro-apply .customer-form .field-validation-valid + .form-input-sml:after,
  form.newsletter-thankyou .field-validation-valid + .form-input-sml:after {
    content: url("//images.arcteryx.com/foundation-ui/forms/check.svg");
    display: block;
    width: 15px;
    height: 15px;
    right: -20px;
    top: 40%;
    position: absolute;
  }

  .CHECKOUT form.return-form .field-validation-valid + .form-input-sml:after,
  .CHECKOUT form.customer-form .field-validation-valid + .form-input-sml:after,
  .CHECKOUT form.profile-form .field-validation-valid + .form-input-sml:after,
  .CHECKOUT
    .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-sml:after,
  .CHECKOUT
    form.newsletter-thankyou
    .field-validation-valid
    + .form-input-sml:after {
    right: 20px;
  }

  @media screen and (max-width: 479px) {
    form.return-form .field-validation-valid + .form-input-sml:after,
    form.customer-form .field-validation-valid + .form-input-sml:after,
    form.profile-form .field-validation-valid + .form-input-sml:after,
    .pro-apply .customer-form .field-validation-valid + .form-input-sml:after,
    form.newsletter-thankyou .field-validation-valid + .form-input-sml:after {
      top: 43%;
      right: 5%;
      left: auto;
      position: absolute;
    }
  }

  form.return-form .field-validation-error + .form-input-sml:after,
  form.customer-form .field-validation-error + .form-input-sml:after,
  form.profile-form .field-validation-error + .form-input-sml:after,
  .pro-apply .customer-form .field-validation-error + .form-input-sml:after,
  form.newsletter-thankyou .field-validation-error + .form-input-sml:after {
    content: url("//images.arcteryx.com/foundation-ui/forms/caution.svg");
    display: block;
    width: 15px;
    height: 15px;
    right: -20px;
    top: 40%;
    position: absolute;
  }

  .CHECKOUT form.return-form .field-validation-error + .form-input-sml:after,
  .CHECKOUT form.customer-form .field-validation-error + .form-input-sml:after,
  .CHECKOUT form.profile-form .field-validation-error + .form-input-sml:after,
  .CHECKOUT
    .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-sml:after,
  .CHECKOUT
    form.newsletter-thankyou
    .field-validation-error
    + .form-input-sml:after {
    right: 20px;
  }

  @media screen and (max-width: 479px) {
    form.return-form .field-validation-error + .form-input-sml:after,
    form.customer-form .field-validation-error + .form-input-sml:after,
    form.profile-form .field-validation-error + .form-input-sml:after,
    .pro-apply .customer-form .field-validation-error + .form-input-sml:after,
    form.newsletter-thankyou .field-validation-error + .form-input-sml:after {
      top: 43%;
      right: 5%;
      left: auto;
      position: absolute;
    }
  }

  form.return-form .field-validation-error + .form-input-sml input[type="text"],
  form.return-form
    .field-validation-error
    + .form-input-sml
    input[type="number"],
  form.customer-form
    .field-validation-error
    + .form-input-sml
    input[type="text"],
  form.customer-form
    .field-validation-error
    + .form-input-sml
    input[type="number"],
  form.profile-form
    .field-validation-error
    + .form-input-sml
    input[type="text"],
  form.profile-form
    .field-validation-error
    + .form-input-sml
    input[type="number"],
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-sml
    input[type="text"],
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-sml
    input[type="number"],
  form.newsletter-thankyou
    .field-validation-error
    + .form-input-sml
    input[type="text"],
  form.newsletter-thankyou
    .field-validation-error
    + .form-input-sml
    input[type="number"] {
    border: 1px solid #9d1d1d;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
  }

  form.return-form
    .field-validation-error
    + .form-input-sml
    input[type="text"]:focus,
  form.return-form
    .field-validation-error
    + .form-input-sml
    input[type="number"]:focus,
  form.customer-form
    .field-validation-error
    + .form-input-sml
    input[type="text"]:focus,
  form.customer-form
    .field-validation-error
    + .form-input-sml
    input[type="number"]:focus,
  form.profile-form
    .field-validation-error
    + .form-input-sml
    input[type="text"]:focus,
  form.profile-form
    .field-validation-error
    + .form-input-sml
    input[type="number"]:focus,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-sml
    input[type="text"]:focus,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-sml
    input[type="number"]:focus,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input-sml
    input[type="text"]:focus,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input-sml
    input[type="number"]:focus {
    border: 2px solid #bcd9e7;
    background: #f7f7f7;
    border-radius: 3px;
  }

  form.return-form select,
  form.customer-form select,
  form.profile-form select,
  .pro-apply .customer-form select,
  form.newsletter-thankyou select {
    width: 100%;
    max-width: 100%;
    float: left;
  }

  form.return-form select:focus,
  form.customer-form select:focus,
  form.profile-form select:focus,
  .pro-apply .customer-form select:focus,
  form.newsletter-thankyou select:focus {
    outline: none;
    border: 1px solid var(--focus-blue);
    background: var(--colour-white);
  }

  form.return-form .field-validation-valid + .form-input-selection:after,
  form.customer-form .field-validation-valid + .form-input-selection:after,
  form.profile-form .field-validation-valid + .form-input-selection:after,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-selection:after,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input-selection:after {
    content: url("//images.arcteryx.com/foundation-ui/forms/check.svg");
    display: block;
    width: 15px;
    height: 15px;
    right: -20px;
    top: 40%;
    position: absolute;
  }

  .CHECKOUT
    form.return-form
    .field-validation-valid
    + .form-input-selection:after,
  .CHECKOUT
    form.customer-form
    .field-validation-valid
    + .form-input-selection:after,
  .CHECKOUT
    form.profile-form
    .field-validation-valid
    + .form-input-selection:after,
  .CHECKOUT
    .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-selection:after,
  .CHECKOUT
    form.newsletter-thankyou
    .field-validation-valid
    + .form-input-selection:after {
    right: 20px;
  }

  @media screen and (max-width: 479px) {
    form.return-form .field-validation-valid + .form-input-selection:after,
    form.customer-form .field-validation-valid + .form-input-selection:after,
    form.profile-form .field-validation-valid + .form-input-selection:after,
    .pro-apply
      .customer-form
      .field-validation-valid
      + .form-input-selection:after,
    form.newsletter-thankyou
      .field-validation-valid
      + .form-input-selection:after {
      top: 43%;
      right: 5%;
      left: auto;
      position: absolute;
    }
  }

  form.return-form .field-validation-valid + .form-input-selection select,
  form.customer-form .field-validation-valid + .form-input-selection select,
  form.profile-form .field-validation-valid + .form-input-selection select,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-selection
    select,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input-selection
    select {
    border: 1px solid #3fa755;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    padding-right: 4px;
  }

  form.return-form .field-validation-valid + .form-input-selection select:focus,
  form.customer-form
    .field-validation-valid
    + .form-input-selection
    select:focus,
  form.profile-form
    .field-validation-valid
    + .form-input-selection
    select:focus,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-selection
    select:focus,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input-selection
    select:focus {
    border: 1px solid #bcd9e7;
    background: #f7f7f7;
  }

  form.return-form .field-validation-error + .form-input-selection:after,
  form.customer-form .field-validation-error + .form-input-selection:after,
  form.profile-form .field-validation-error + .form-input-selection:after,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-selection:after,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input-selection:after {
    content: url("//images.arcteryx.com/foundation-ui/forms/caution.svg");
    display: block;
    width: 15px;
    height: 15px;
    right: -20px;
    top: 40%;
    position: absolute;
  }

  .CHECKOUT
    form.return-form
    .field-validation-error
    + .form-input-selection:after,
  .CHECKOUT
    form.customer-form
    .field-validation-error
    + .form-input-selection:after,
  .CHECKOUT
    form.profile-form
    .field-validation-error
    + .form-input-selection:after,
  .CHECKOUT
    .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-selection:after,
  .CHECKOUT
    form.newsletter-thankyou
    .field-validation-error
    + .form-input-selection:after {
    right: 20px;
  }

  @media screen and (max-width: 479px) {
    form.return-form .field-validation-error + .form-input-selection:after,
    form.customer-form .field-validation-error + .form-input-selection:after,
    form.profile-form .field-validation-error + .form-input-selection:after,
    .pro-apply
      .customer-form
      .field-validation-error
      + .form-input-selection:after,
    form.newsletter-thankyou
      .field-validation-error
      + .form-input-selection:after {
      top: 43%;
      right: 5%;
      left: auto;
      position: absolute;
    }
  }

  form.return-form .field-validation-error + .form-input-selection select,
  form.customer-form .field-validation-error + .form-input-selection select,
  form.profile-form .field-validation-error + .form-input-selection select,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-selection
    select,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input-selection
    select {
    border: 1px solid #a30200;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    padding-right: 4px;
  }

  form.return-form .field-validation-error + .form-input-selection select:focus,
  form.customer-form
    .field-validation-error
    + .form-input-selection
    select:focus,
  form.profile-form
    .field-validation-error
    + .form-input-selection
    select:focus,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-selection
    select:focus,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input-selection
    select:focus {
    border: 1px solid #bcd9e7;
    background: #f7f7f7;
  }

  form.return-form .form-input-selection select:focus,
  form.customer-form .form-input-selection select:focus,
  form.profile-form .form-input-selection select:focus,
  .pro-apply .customer-form .form-input-selection select:focus,
  form.newsletter-thankyou .form-input-selection select:focus {
    border: 1px solid #bcd9e7;
    background: #f7f7f7;
  }

  form.return-form .field-validation-valid + .form-input-file:after,
  form.customer-form .field-validation-valid + .form-input-file:after,
  form.profile-form .field-validation-valid + .form-input-file:after,
  .pro-apply .customer-form .field-validation-valid + .form-input-file:after,
  form.newsletter-thankyou .field-validation-valid + .form-input-file:after {
    content: url("//images.arcteryx.com/foundation-ui/forms/check.svg");
    display: block;
    width: 15px;
    height: 15px;
    left: 0;
    top: 40%;
    position: absolute;
  }

  form.return-form .field-validation-error + .form-input-file:after,
  form.customer-form .field-validation-error + .form-input-file:after,
  form.profile-form .field-validation-error + .form-input-file:after,
  .pro-apply .customer-form .field-validation-error + .form-input-file:after,
  form.newsletter-thankyou .field-validation-error + .form-input-file:after {
    content: url("//images.arcteryx.com/foundation-ui/forms/caution.svg");
    display: block;
    width: 15px;
    height: 15px;
    left: 0;
    top: 1px;
    position: absolute;
  }

  form.return-form
    .field-validation-error
    + .form-input-file
    input[type="file"],
  form.customer-form
    .field-validation-error
    + .form-input-file
    input[type="file"],
  form.profile-form
    .field-validation-error
    + .form-input-file
    input[type="file"],
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-file
    input[type="file"],
  form.newsletter-thankyou
    .field-validation-error
    + .form-input-file
    input[type="file"] {
    border: 1px solid #a30200;
    vertical-align: middle;
    padding-right: 12px;
  }

  form.return-form
    .field-validation-error
    + .form-input-file
    input[type="file"]:focus,
  form.customer-form
    .field-validation-error
    + .form-input-file
    input[type="file"]:focus,
  form.profile-form
    .field-validation-error
    + .form-input-file
    input[type="file"]:focus,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-file
    input[type="file"]:focus,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input-file
    input[type="file"]:focus {
    border: none;
  }

  form.return-form
    .field-validation-valid
    + .form-input-file
    input[type="file"],
  form.customer-form
    .field-validation-valid
    + .form-input-file
    input[type="file"],
  form.profile-form
    .field-validation-valid
    + .form-input-file
    input[type="file"],
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-file
    input[type="file"],
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input-file
    input[type="file"] {
    border: 1px solid #3fa755;
    vertical-align: middle;
    padding-right: 12px;
  }

  form.return-form
    .field-validation-valid
    + .form-input-file
    input[type="file"]:focus,
  form.customer-form
    .field-validation-valid
    + .form-input-file
    input[type="file"]:focus,
  form.profile-form
    .field-validation-valid
    + .form-input-file
    input[type="file"]:focus,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-file
    input[type="file"]:focus,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input-file
    input[type="file"]:focus {
    border: none;
  }

  form.return-form .form-row textarea,
  form.customer-form .form-row textarea,
  form.profile-form .form-row textarea,
  .pro-apply .customer-form .form-row textarea,
  form.newsletter-thankyou .form-row textarea {
    float: left;
    border: 1px solid #999;
    height: 92px;
    width: 100%;
    background: #fff;
    border-radius: 3px;
    padding: 0 0 0 6px;
    color: #333;
    line-height: 1.3em;
    font-size: 16px;
    -webkit-transition: all 0.45s ease-in-out;
    transition: all 0.45s ease-in-out;
  }

  form.return-form .form-row textarea:focus,
  form.customer-form .form-row textarea:focus,
  form.profile-form .form-row textarea:focus,
  .pro-apply .customer-form .form-row textarea:focus,
  form.newsletter-thankyou .form-row textarea:focus {
    border: 2px solid #bcd9e7;
    background: #f1f6f8;
    border-radius: 3px;
    outline: none;
  }

  form.return-form .field-validation-valid + .form-input-textarea textarea,
  form.customer-form .field-validation-valid + .form-input-textarea textarea,
  form.profile-form .field-validation-valid + .form-input-textarea textarea,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-textarea
    textarea,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input-textarea
    textarea {
    border: 1px solid #3fa755;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
  }

  form.return-form
    .field-validation-valid
    + .form-input-textarea
    textarea:focus,
  form.customer-form
    .field-validation-valid
    + .form-input-textarea
    textarea:focus,
  form.profile-form
    .field-validation-valid
    + .form-input-textarea
    textarea:focus,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-textarea
    textarea:focus,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input-textarea
    textarea:focus {
    border: 2px solid #bcd9e7;
    background: #f1f6f8;
    border-radius: 3px;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  form.return-form .field-validation-valid + .form-input-textarea:after,
  form.customer-form .field-validation-valid + .form-input-textarea:after,
  form.profile-form .field-validation-valid + .form-input-textarea:after,
  .pro-apply
    .customer-form
    .field-validation-valid
    + .form-input-textarea:after,
  form.newsletter-thankyou
    .field-validation-valid
    + .form-input-textarea:after {
    content: url("//images.arcteryx.com/foundation-ui/forms/check.svg");
    display: block;
    width: 15px;
    height: 15px;
    left: 0;
    top: 40%;
    position: absolute;
  }

  @media screen and (max-width: 479px) {
    form.return-form .field-validation-valid + .form-input-textarea:after,
    form.customer-form .field-validation-valid + .form-input-textarea:after,
    form.profile-form .field-validation-valid + .form-input-textarea:after,
    .pro-apply
      .customer-form
      .field-validation-valid
      + .form-input-textarea:after,
    form.newsletter-thankyou
      .field-validation-valid
      + .form-input-textarea:after {
      top: 31%;
      right: 6%;
      left: 90%;
      position: absolute;
    }
  }

  form.return-form .field-validation-error + .form-input-textarea textarea,
  form.customer-form .field-validation-error + .form-input-textarea textarea,
  form.profile-form .field-validation-error + .form-input-textarea textarea,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-textarea
    textarea,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input-textarea
    textarea {
    border: 1px solid #a30200;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
  }

  form.return-form
    .field-validation-error
    + .form-input-textarea
    textarea:focus,
  form.customer-form
    .field-validation-error
    + .form-input-textarea
    textarea:focus,
  form.profile-form
    .field-validation-error
    + .form-input-textarea
    textarea:focus,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-textarea
    textarea:focus,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input-textarea
    textarea:focus {
    border: 2px solid #bcd9e7;
    background: #f1f6f8;
    border-radius: 3px;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  form.return-form .field-validation-error + .form-input-textarea:after,
  form.customer-form .field-validation-error + .form-input-textarea:after,
  form.profile-form .field-validation-error + .form-input-textarea:after,
  .pro-apply
    .customer-form
    .field-validation-error
    + .form-input-textarea:after,
  form.newsletter-thankyou
    .field-validation-error
    + .form-input-textarea:after {
    content: url("//images.arcteryx.com/foundation-ui/forms/caution.svg");
    display: block;
    width: 15px;
    height: 15px;
    left: 0px;
    padding-top: 10px;
    vertical-align: top;
    top: 6px;
    position: absolute;
  }

  @media screen and (max-width: 479px) {
    form.return-form .field-validation-error + .form-input-textarea:after,
    form.customer-form .field-validation-error + .form-input-textarea:after,
    form.profile-form .field-validation-error + .form-input-textarea:after,
    .pro-apply
      .customer-form
      .field-validation-error
      + .form-input-textarea:after,
    form.newsletter-thankyou
      .field-validation-error
      + .form-input-textarea:after {
      top: 31%;
      right: 6%;
      left: 90%;
      position: absolute;
    }
  }

  form.return-form input[type="text"].datas,
  form.customer-form input[type="text"].datas,
  form.profile-form input[type="text"].datas,
  .pro-apply .customer-form input[type="text"].datas,
  form.newsletter-thankyou input[type="text"].datas {
    -webkit-appearance: menulist;
    color: #999;
  }

  form.return-form input[type="date"],
  form.customer-form input[type="date"],
  form.profile-form input[type="date"],
  .pro-apply .customer-form input[type="date"],
  form.newsletter-thankyou input[type="date"] {
    color: #999;
    -webkit-appearance: none;
  }

  form.return-form input::-webkit-calendar-picker-indicator,
  form.customer-form input::-webkit-calendar-picker-indicator,
  form.profile-form input::-webkit-calendar-picker-indicator,
  .pro-apply .customer-form input::-webkit-calendar-picker-indicator,
  form.newsletter-thankyou input::-webkit-calendar-picker-indicator {
    display: none;
  }

  form.return-form input[type="checkbox"]:after,
  form.customer-form input[type="checkbox"]:after,
  form.profile-form input[type="checkbox"]:after,
  .pro-apply .customer-form input[type="checkbox"]:after,
  form.newsletter-thankyou input[type="checkbox"]:after {
    padding-left: 20px;
  }

  form.return-form input[type="submit"],
  form.return-form button#submit,
  form.customer-form input[type="submit"],
  form.customer-form button#submit,
  form.profile-form input[type="submit"],
  form.profile-form button#submit,
  .pro-apply .customer-form input[type="submit"],
  .pro-apply .customer-form button#submit,
  form.newsletter-thankyou input[type="submit"],
  form.newsletter-thankyou button#submit {
    width: 96%;
    max-width: 100%;
    max-width: 430px;
  }

  form.return-form input[type="submit"],
  form.customer-form input[type="submit"],
  form.profile-form input[type="submit"],
  .pro-apply .customer-form input[type="submit"],
  form.newsletter-thankyou input[type="submit"] {
    width: 100% !important;
  }

  form.return-form select.sml-select,
  form.customer-form select.sml-select,
  form.profile-form select.sml-select,
  .pro-apply .customer-form select.sml-select,
  form.newsletter-thankyou select.sml-select {
    width: 160px;
  }

  form.return-form .rht-align,
  form.customer-form .rht-align,
  form.profile-form .rht-align,
  .pro-apply .customer-form .rht-align,
  form.newsletter-thankyou .rht-align {
    display: inline-block;
    float: right;
    color: #666;
    clear: both;
    width: 100%;
    padding: 0.9em 0.9em 0.9em 0;
    position: relative;
    left: 2.2em;
  }

  form.profile-form {
    padding: 0;
  }

  form.return-form input[type="checkbox"] {
    font-size: 18px;
    margin: 0 1em 0 0;
  }

  @media screen and (min-width: 480px) {
    form.return-form input[type="checkbox"] {
      margin: 0;
    }
  }

  form.return-form .product-info {
    padding: 0;
  }

  form.return-form .product-quantity {
    padding: 0;
  }

  form.return-form .product-quantity button {
    float: left;
    height: 44px;
  }

  form.return-form .product-quantity .number-input input {
    margin: 0;
    padding: 0;
    max-width: 40px;
  }

  form.return-form .return-reason {
    padding: 0;
    margin: 1em 0;
  }

  @media screen and (min-width: 768px) {
    form.return-form .return-reason {
      margin: 0;
    }
  }

  form.return-form .return-reason select.no-reason-selected {
    border: 1px solid #a30200;
  }

  form.return-form .return-reason span.invalid-reason {
    color: #a30200;
    font-style: italic;
  }

  form.newsletter-thankyou {
    max-width: 100%;
  }

  form.newsletter-thankyou .inner-container {
    max-width: 100% !important;
  }

  form.newsletter-thankyou #divActivities label {
    width: auto;
  }

  input#AreYouDealer {
    margin: 0 2px 0 10px;
  }

  #repairFormDealer {
    display: none;
  }

  @media screen and (max-width: 929px) {
    .WARRANTY #minorContent {
      margin-bottom: 40px;
    }
  }

  .limitedWarrantyContent {
    background-color: #fff;
    width: 100%;
    height: 100%;
    position: relative;
    max-height: 100% !important;
    z-index: 1;
    padding: 25px;
    font-size: 15px;
    line-height: 1.5;
  }

  .limitedWarrantyContent p {
    margin-bottom: 10px;
  }

  .email__opt-in {
    font-size: 15px;
    line-height: 1.3em;
    font-style: normal;
  }

  .email__opt-in input[type="checkbox"] {
    float: left;
    font-size: 18px;
    margin: 2px 5px 0 0;
  }

  #content .email__opt-in span {
    display: inline;
    width: auto;
    font-style: normal;
    cursor: default;
    text-decoration: none !important;
  }

  .login-form__header {
    text-align: center;
  }

  @media screen and (min-width: 768px) {
    .login-form__header h1 {
      padding-right: 30px;
    }
  }

  .login-form__header h2 {
    margin: 0 0 0.25em 0;
  }

  #content .login-form__header-description,
  .login-form__header-description {
    margin: 0 auto 3em !important;
  }

  .tooltip {
    font-size: 0;
    line-height: 0;
    position: relative;
    display: block;
    float: right;
    color: transparent;
  }

  .tooltip:after {
    content: url(//images.arcteryx.com/foundation-ui/svgs/Question_Icon.svg);
    width: 16px;
    margin: 0 auto;
    display: inline-block;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 260px;
    background: var(--colour-black);
    color: #fff;
    padding: 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    z-index: 99999;
    bottom: 30px;
    left: 25%;
    margin-left: -130px;
  }

  @media screen and (max-width: 767px) {
    .tooltip .tooltiptext {
      width: 320px;
      left: initial;
      right: 0;
    }
  }

  .tooltip .tooltiptext::after {
    position: absolute;
    content: "";
    display: block;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom-width: 0;
    border-top-color: var(--colour-black);
    left: 50%;
    top: 100%;
  }

  @media screen and (max-width: 767px) {
    .tooltip .tooltiptext::after {
      left: initial;
      right: 0.5px;
    }
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

  .OUTDOORRETURNS .ui-tooltip,
  .ORDERSTATUS .ui-tooltip {
    display: none;
  }

  html {
    background-color: transparent;
  }

  .hidden {
    display: none;
  }

  .SegLevel2 {
    padding-left: 1em;
  }

  .SegLevel3 {
    padding-left: 2em;
  }

  .SegLevel4 {
    padding-left: 3em;
  }

  .SegError {
    color: #b30000;
  }

  // ----------

  form.return-form label,
  form.customer-form label,
  form.profile-form label,
  .pro-apply .customer-form label,
  form.newsletter-thankyou label {
    padding: 0;
  }

  // -----------
  @media (max-width: 768px) {
    #customer-form {
      margin-top: 10px;
    }
  }

  #content.customer-support-centre .customer-form textarea,
  #content .account__help-content .customer-form textarea,
  #content.help .customer-form textarea {
    margin-bottom: 0 !important;
  }

  #content p {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  #content.customer-support-centre h1,
  #content.customer-support-centre h2,
  #content.customer-support-centre a,
  #content.customer-support-centre .breadcrumb .breadcrumb__list-item * {
    color: var(--colour-black);
  }

  #content.customer-support-centre h1 {
    ${H1Styles({ variant: Variant.MEDIUM })};
    padding-top: 16px;
  }

  form.customer-form button {
    ${Button1Styles};
  }
`;
